<template>
  <div class="insurance">
    <div class="indexBigBanner contentWidth">
      <img src="../../assets/img/index/indexAbanner.png"   class="indexAbanner" alt="">
      
      <div class="indexBigBannerSwiper " @mouseenter="stopSwiper" @mouseleave="playSwiper">
              
        <swiper :options="swiperOption3" ref="mySwipe1New">
          <swiper-slide v-for="(i,index) in con32KP1" 
          :key="i.news">
            <div class="luoIndexBI" style="cursor: pointer;"> 
              <img :src="i.img">
              <span class='luoIndexBITitle'>{{i.title}}</span><br>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper_button_prev_new" style=''></div>
        <div class="swiper_button_next_new" style=''></div>
      </div>

      <div class="indexBigTextBg">
          <!-- <div style="width:960px;background: rgba(0, 0, 0,0.0);overflow:hidden;"> -->
          <div style="width:1155px;background: rgba(0, 0, 0,0.0);overflow:hidden;"> 
            <div class="titleTY" style="align-items:flex-start;margin-bottom:0;margin-top:0;">
              <span class="titleTY_top" style="text-shadow:1px 1px 0 rgba(0,0,0,0.6);color:#fff;background:rgba(0, 142, 207,0);padding:4px 10px;margin-bottom:-10px;font-size:18px;">
                关于数聚智连
              </span>
              <span class="titleTY_bot" style="text-shadow:1px 1px 0 rgba(0,0,0,0.6);color:#fff;background:rgba(0, 142, 207,0);padding:4px 10px;margin-bottom:6px;font-size:12px;">
                ABOUT US
              </span>
            </div>


            <span class="indexBigTextContent">北京数聚智连科技股份有限公司是一家以效果营销驱动销售的整合型、全链路品牌运营公司。公司立足于国内和海外并行的双市场战略，致力于帮助国内外品牌在中国市场和海外市场实现销售成功。数聚智连服务于天猫、京东、抖音等国内主流电商平台，以及亚马逊、TikTok等海外电商平台，是天猫五星、天猫国际金星、京东“京卓越”等平台认可的优秀代运营服务商，也屡次在艾菲、金投赏等国内外营销评奖中获得金奖等奖项。目前数聚智连服务超过50个全球和本土知名品牌，帮助其品牌和业务在中国扩张。数聚智连总部位于北京，在中国上海、杭州等地设有分支机构和香港子公司。数聚智连是北京服务业百强企业和中关村高新技术企业，获得ISO9001质量管理体系和ISO27001信息安全管理体系双认证。</span>

          </div>
      </div>
    </div>
    <div class="indexBanner" v-if="false">
      <div class="titleTY" style="margin-bottom:0;">
        <span class="titleTY_top">
          所获奖项
        </span>
        <span class="titleTY_bot">
          RECEIVING PRIZES
        </span>
      </div>

      <!-- contentWidth -->
      <div class="insuranceCon32 "  style='position:relative;margin-top:-220px;z-index:900;'>
        
        <swiper :options="swiperOption3" ref="mySwipe1r2">
          <swiper-slide v-for="(i,index) in con32KP1" :key='index'>
            <div class="luoIndexBI">
              <img :src="i.img">
              <span class='luoIndexBITitle'>{{i.title}}</span><br>
            </div>
          </swiper-slide>
        </swiper>
        <!-- <div class="swiper-button-prev" style='height:40%;left:320px !important;'></div>
        <div class="swiper-button-next" style='height:40%;right:320px !important;'></div> -->
      </div>


    </div>


    <div class="buged" v-if="false">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(i,index) in bannerImg" :key='index'>
            <img :src="i" class="swiperImg">
        </swiper-slide>
      </swiper>
    </div>

    <div class="insuranceCon1" id="insuranceCon1" v-if="false">
      
      <!-- <div class="titleTY">
        <span class="titleTY_top">
          关于数聚智连
        </span>
        <span class="titleTY_bot">
          ABOUT US
        </span>
      </div> -->

      <div class="insuranceCon11 contentWidth">
        <div class="insuranceCon11_left" v-if="false">
          <img src="../../assets/img/index/sb.png" alt="">
          <div class="insuranceAbout">
            <span class="insuranceAbout_top">
              ABOUT US
            </span><br>
            <span class="insuranceAbout_bot">
              关于数聚智连
            </span>
          </div>
        </div>
        <div class="insuranceCon11_right" style="width:100%;padding-top:0;padding-bottom:0;">
          <!-- <span></span> -->
          <p style="display:flex;flex-direction: row;justify-content: space-betweenl;">
            <span>北京数聚智连科技股份有限公司是一家以效果营销驱动销售的整合型全链路品牌运营公司。公司立足于国内市场和海外市场并行的双市场战略，致力于帮助国内外品牌在中国市场和海外市场实现销售成功。数聚智连总部位于北京，在中国上海、杭州等地设有分支机构和香港子公司。公司获得ISO9001质量管理体系和ISO27001信息安全管理体系双认证。</span>
            
            <span style="display:flex;flex-direction: row;width:160px;flex-shrink:0;margin-left:20px;">
              <img style="margin-top: 0px; width: 65px;height:65px;" src="../../assets/img/index/ISO9001.jpg" alt=""/>
              <img style="margin-top: 0px;margin-left: 20px; width: 65px;height:65px;" src="../../assets/img/index/ISO27001.jpg" alt=""/>
            </span>
          </p>
        </div>
      </div>
      <div class="insuranceCon12 contentWidth" v-if="false">
        <div class="insuranceCon12To" @mouseover='ImgMouse(0)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==0?'1':'0')">
            <span :class="ImgHover==0?'ZhuanN':'ZhuanY'"></span>
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<3?'ImgBig':'ImgMix'" src="../../assets/img/index/bk1.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(1)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==1?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==1" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<3?'ImgBig':'ImgMix'" src="../../assets/img/index/bk2.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(2)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==2?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==2" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<3?'ImgBig':'ImgMix'" src="../../assets/img/index/bk3.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(3)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==3?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==3" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<5?'ImgBig':'ImgMix'" src="../../assets/img/index/bk4.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(4)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==4?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<5?'ImgBig':'ImgMix'" src="../../assets/img/index/bk5.jpg" alt="">
        </div>
        <div class="insuranceCon12To" @mouseover='ImgMouse(5)'>
          <div class="insuranceCon12Zhe" :style="'opacity:'+(ImgHover==5?'1':'0')">
            <!-- <span></span> -->
<!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg v-if="ImgHover==5" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
viewBox="0 0 180.83 46.361" style="enable-background:new 0 0 180.83 46.361;" xml:space="preserve">
<g id="&#x80CC;&#x666F;">
</g>
<g id="&#x56FE;&#x5C42;_1">
<g>
<g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M81.46-0.033V22.75h-3.854V-0.033H81.46z"/>
<rect style="fill:#fff;" stroke='#fff' x="140.819" y="0.04" width="3.874" height="3.858"/>
<path style="fill:#fff;" stroke='#fff' d="M86.021,5.831h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.831z"/>
<path style="fill:#fff;" stroke='#fff' d="M129.62,0.934l11.078,19.933l-3.375,1.876L126.245,2.809L129.62,0.934z"/>
<path style="fill:#fff;" stroke='#fff' d="M144.681,5.815V22.75h-3.861V5.815H144.681z"/>
<path style="fill:#fff;" stroke='#fff' d="M125.667,19.06h-4.246c-2.959,0-5.026-1.861-5.026-4.527c0-2.79,2.27-5.06,5.059-5.06h0.934
l-1.778,5.498h3.947l3.299-9.17h-6.401c-4.815,0-8.73,3.917-8.73,8.731c0,4.674,3.739,8.198,8.697,8.198h6.443L125.667,19.06z"
/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.856,5.692c-0.403-0.83-0.905-1.603-1.491-2.296c-0.59-0.698-1.274-1.303-2.035-1.8
c-0.76-0.496-1.607-0.885-2.517-1.157c-0.912-0.272-1.899-0.41-2.934-0.41H0.008v22.686H8.88c1.501,0,2.898-0.296,4.151-0.879
c1.25-0.582,2.34-1.398,3.24-2.427c0.895-1.022,1.598-2.237,2.092-3.612c0.491-1.369,0.74-2.871,0.74-4.464
c0-1.015-0.107-2.011-0.319-2.959C18.572,7.424,18.26,6.522,17.856,5.692z M3.493,3.222H7.93c1.103,0,2.139,0.164,3.079,0.488
c0.922,0.318,1.734,0.81,2.413,1.462c0.677,0.652,1.217,1.497,1.605,2.514c0.392,1.031,0.591,2.274,0.591,3.695
c0,1.297-0.196,2.467-0.583,3.477c-0.383,1.001-0.921,1.855-1.599,2.54c-0.676,0.684-1.491,1.214-2.422,1.575
c-0.94,0.365-1.977,0.55-3.083,0.55H3.493V3.222z"/>
<path style="fill:#fff;" stroke='#fff' d="M32.297,5.843c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.846l-3.229,0L32.297,5.843z M31.996,9.289l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C31.524,9.271,31.757,9.277,31.996,9.289z"/>
</g>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M17.796,40.986c-0.127,0.253-0.254,0.498-0.377,0.731c-0.096,0.183-0.019,0.405,0.167,0.495
c0.366,0.178,0.733,0.372,1.099,0.574c0.435-0.468,0.81-1,1.105-1.607c0.043-0.089-0.024-0.193-0.123-0.193H17.796z
M17.753,36.992c-0.699,0.815-1.573,1.583-2.389,2.052c-0.145-0.329-0.451-0.814-0.713-1.095
c0.946-0.408,1.981-1.254,2.68-2.162h-2.462v-1.159h2.884v-2.835h1.238v2.835h2.87v1.159H19.37
c0.714,0.454,1.777,1.175,2.083,1.394l-0.729,1.033c-0.349-0.36-1.092-1.002-1.733-1.519v1.942h-1.238V36.992z M20.025,45.105
c-0.32-0.267-0.728-0.564-1.194-0.845c-1.005,0.845-2.199,1.424-3.525,1.801c-0.116-0.312-0.378-0.83-0.612-1.095
c1.122-0.283,2.156-0.721,3.045-1.363c-0.521-0.303-1.074-0.581-1.605-0.825c-0.278-0.128-0.383-0.465-0.23-0.729
c0.191-0.328,0.383-0.695,0.583-1.061h-1.34v-1.19h1.893c0.146-0.344,0.227-0.472,0.355-0.779l1.218,0.058
c-0.088,0.235-0.19,0.469-0.291,0.721h2.473c0.416,0,0.698,0.418,0.548,0.806c-0.411,1.062-1.032,2.066-1.638,2.78
c0.422,0.267,0.83,0.516,1.136,0.752L20.025,45.105z M16.18,34.595c-0.117-0.547-0.481-1.394-0.859-2.02l0.99-0.439
c0.379,0.596,0.772,1.41,0.903,1.974L16.18,34.595z M21.584,32.56c-0.437,0.704-0.903,1.456-1.297,1.942l-0.874-0.423
c0.349-0.564,0.786-1.426,1.034-2.035L21.584,32.56z M26.958,36.099c-0.306,2.271-0.757,4.166-1.5,5.732
c0.714,1.331,1.631,2.381,2.782,3.07c-0.306,0.251-0.685,0.783-0.889,1.129c-1.063-0.69-1.923-1.692-2.622-2.882
c-0.83,1.269-1.908,2.287-3.336,3.085c-0.116-0.297-0.495-0.908-0.713-1.19c1.515-0.768,2.607-1.817,3.394-3.226
c-0.481-1.127-0.874-2.381-1.165-3.758c-0.262,0.657-0.568,1.237-0.889,1.738c-0.203-0.251-0.713-0.705-1.005-0.909
c1.136-1.644,1.791-4.244,2.127-6.985l1.238,0.187c-0.117,0.909-0.277,1.802-0.466,2.647h3.686
c0.168,0,0.304,0.136,0.304,0.304v1.058H26.958z M23.681,36.099c0.247,1.504,0.611,2.914,1.092,4.198
c0.422-1.222,0.728-2.6,0.932-4.198H23.681z"/>
<g>
<path style="fill:#fff;" stroke='#fff' d="M157.635,34.803c-0.407-0.751-1.311-1.91-2.039-2.741l-1.034,0.721
c0.728,0.877,1.587,2.083,1.966,2.85L157.635,34.803z"/>
<path style="fill:#fff;" stroke='#fff' d="M162.325,44.295h1.398v-2.57h3.091v-1.377h-3.091v-1.785h2.747v-1.348h-2.747v-1.769h-1.398
v1.769h-1.923c-0.14,0-0.23-0.148-0.166-0.273l1.142-2.201h5.433v-1.254l-4.903,0.008l0.6-1.115l-1.262-0.55l-0.86,1.636
l-2.271,0.022v1.254h1.719l-1.201,2.23c-0.153,0.283-0.171,0.62-0.05,0.919h0c0.166,0.408,0.562,0.675,1.003,0.674
c0.19-0.001,0.4-0.001,0.611-0.001h2.127v1.785h-4.218v1.377h4.218V44.295z"/>
<path style="fill:#fff;" stroke='#fff' d="M158.13,43.934c-0.436-0.297-0.742-0.564-1.005-0.736v-6.077h-3.088v1.347h1.792v4.588
c-0.627,0.282-1.355,0.972-2.068,1.88l0.99,1.426c0.597-1.019,1.223-2.052,1.66-2.052c0.32,0,0.83,0.548,1.442,0.955
c1.077,0.689,2.287,0.861,4.18,0.861c1.486,0,4.05-0.093,5.069-0.172c0.029-0.439,0.262-1.205,0.422-1.629
c-1.456,0.219-3.758,0.361-5.447,0.361C160.403,44.686,159.092,44.577,158.13,43.934z"/>
</g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M111.437,46.258v-0.002h6.556v0.002h1.416v-4.978c0-0.587-0.476-1.064-1.064-1.064h-8.279
v6.042H111.437z M111.435,41.943h0.001v-0.541h6.244c0.172,0,0.312,0.14,0.312,0.312v0.938h-0.001v1.122h0.001v1.281h-6.556
v-0.732h-0.001V41.943z"/>
<path style="fill:#fff;" stroke='#fff' d="M111.585,38.198c0.715,0.528,1.684,1.281,2.116,1.666l0.969-0.977
c-0.402-0.305-2.041-1.346-2.652-1.667l0.044-0.144h2.652V35.89h-2.444c0.015-0.16,0.015-0.32,0.015-0.48v-0.834h2.056V33.39
h-3.859c0.119-0.352,0.238-0.689,0.343-1.057l-1.237-0.273c-0.313,1.186-0.894,2.355-1.639,3.156
c0.283,0.129,0.79,0.481,1.058,0.673h-1.013v1.186h2.697c-0.342,0.898-1.117,1.826-2.846,2.548
c0.313,0.24,0.701,0.704,0.879,0.993C110.185,39.912,111.064,39.062,111.585,38.198z M109.067,35.89
c0.313-0.368,0.611-0.801,0.864-1.314h1.043v0.817c0,0.16,0,0.321-0.015,0.497H109.067z"/>
<path style="fill:#fff;" stroke='#fff' d="M115.281,33.374v5.719h3.319c1.138,0,2.061-0.923,2.061-2.061v-3.659H115.281z M119.289,36.842
c0,0.518-0.42,0.938-0.938,0.938h-1.774v-3.092h2.712V36.842z"/>
<rect style="fill:#fff;" stroke='#fff' x="111.967" y="42.581" width="5.512" height="1.145"/>
</g>
<g>
<g>
<path style="fill:#fff;" stroke='#fff' d="M61.082,37.905l0.146,1.065c1.34-0.142,3.117-0.314,4.923-0.516v0.641h1.209v-0.768
l0.786-0.093v-0.062c0.175,0.235,0.335,0.485,0.437,0.704c0.976-0.376,1.908-0.923,2.709-1.629
c0.816,0.548,1.529,1.097,2.025,1.551l0.859-0.987c-0.495-0.439-1.194-0.94-1.981-1.456c0.541-0.615,1.137-1.488,1.573-2.395
c0.227-0.472-0.115-1.019-0.638-1.019l0,0h-4.736v1.158h3.544c0.152,0,0.248,0.164,0.173,0.296
c-0.269,0.47-0.601,0.914-0.963,1.302c-0.743-0.439-1.515-0.861-2.185-1.206l-0.801,0.847
c0.656,0.36,1.369,0.766,2.068,1.205c-0.64,0.501-1.354,0.909-2.083,1.206l0.014-0.516l-0.801,0.078v-3.822h0.873v-1.065
h-6.89v1.065h1.078v4.308C61.942,37.826,61.476,37.873,61.082,37.905z M63.629,33.635h0.003v-0.148h2.52v0.752h-0.001v0.861
h0.001v0.768h-0.001v0.862h0.001v0.704c-0.874,0.094-1.719,0.172-2.52,0.251v-0.563h-0.003V33.635z"/>
<path style="fill:#fff;" stroke='#fff' d="M62.117,43.214c1.573-0.329,3.569-0.925,4.996-1.519l-1.15-0.658
c-1.253,0.469-3.161,0.908-4.836,1.175C61.432,42.431,61.898,42.964,62.117,43.214z"/>
<path style="fill:#fff;" stroke='#fff' d="M70.492,42.885c1.049-0.454,2.287-1.08,3.278-1.706l-1.092-0.768
c-0.801,0.564-2.097,1.299-3.147,1.785c-0.422-0.344-0.771-0.721-1.063-1.127v-0.721c1.631-0.189,3.205-0.423,4.443-0.69
l-0.961-0.923c-2.433,0.485-6.657,0.83-9.949,0.83c0.234,0.297,0.554,0.923,0.714,1.237c1.34-0.062,2.87-0.172,4.413-0.314
v2.82l-0.859-0.486c-1.296,0.721-3.394,1.426-5.258,1.817c0.321,0.25,0.83,0.783,1.092,1.08
c1.588-0.454,3.569-1.19,5.025-1.973v2.552h1.34V42.76c1.369,1.379,3.278,2.334,5.375,2.82
c0.175-0.376,0.539-0.909,0.801-1.191C73.099,44.138,71.672,43.605,70.492,42.885z"/>
</g>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="34.274" width="1.876" height="0.829"/>
<rect style="fill:#fff;" stroke='#fff' x="63.941" y="35.718" width="1.876" height="0.829"/>
</g>
</g>
</g>
</g>
<path style="fill:#fff;" stroke='#fff' d="M174.477,12.463c0.992,1.685,2.009,3.398,3.051,5.137c1.041,1.74,2.058,3.452,3.051,5.137h-4.368
l-4.433-7.567c-0.251,0.25-0.486,0.484-0.704,0.701c-0.218,0.218-0.415,0.418-0.589,0.603c-0.196,0.207-0.387,0.402-0.573,0.587
v5.675h-3.86V0.004h3.86v12.215l6.2-6.083h4.711L174.477,12.463z"/>
<path style="fill:#fff;" stroke='#fff' d="M108.228,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.92h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372V8.92h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C107.224,22.64,107.715,22.744,108.228,22.744
C108.227,22.744,108.228,22.744,108.228,22.744z"/>
<!-- <rect style="fill:#fff;" stroke='#fff' x="109.334" y="19.6" style="fill:#fff;" width="2.299" height="0.56"/> -->
<path style="fill:#fff;" stroke='#fff' d="M46.211,22.744h3.419v-3.16h-2.135c-0.026,0.001-0.054,0.002-0.074,0.002
c-0.008,0-0.014-0.002-0.022-0.002h-0.066v-0.007c-0.338-0.023-0.608-0.168-0.804-0.449c-0.213-0.305-0.319-0.687-0.319-1.145
V8.921h3.059V5.763h-3.059v-4.58h-3.86v4.58h-2.372v3.157h2.372v9.488c0,0.655,0.103,1.249,0.311,1.783
c0.207,0.535,0.488,0.99,0.843,1.366c0.354,0.376,0.766,0.668,1.235,0.875C45.207,22.64,45.698,22.744,46.211,22.744
C46.211,22.744,46.211,22.744,46.211,22.744z"/>
<path style="fill:#fff;" stroke='#fff' d="M61.526,5.911c-3.389-0.185-6.072,0.569-7.975,2.244c-1.79,1.579-2.776,3.956-2.776,6.693
c0,4.719,3.537,7.89,8.802,7.89h7.511V5.914l-3.229,0L61.526,5.911z M61.225,9.357l2.267,0.134v9.79h-3.915
c-3.211,0-5.205-1.699-5.205-4.433c0-1.242,0.28-2.969,1.611-4.144c1.028-0.907,2.554-1.365,4.544-1.365
C60.753,9.339,60.986,9.345,61.225,9.357z"/>
<path style="fill:#fff;" stroke='#fff' d="M148.439,5.845h3.835v2.292c0.715-0.812,1.465-1.395,2.25-1.747
c0.785-0.352,1.589-0.528,2.413-0.528c0.845,0,1.603,0.125,2.275,0.374c0.671,0.249,1.237,0.604,1.698,1.064
c0.46,0.46,0.815,1.013,1.064,1.657c0.249,0.645,0.374,1.362,0.374,2.153v11.617h-3.835v-11c0-0.422-0.059-0.796-0.179-1.121
c-0.119-0.325-0.281-0.601-0.487-0.828c-0.206-0.228-0.45-0.398-0.731-0.512c-0.282-0.114-0.58-0.171-0.894-0.171
c-0.509,0-1.002,0.106-1.479,0.317c-0.477,0.211-0.897,0.493-1.259,0.845c-0.363,0.352-0.656,0.758-0.877,1.219
c-0.222,0.46-0.333,0.94-0.333,1.438v9.814h-3.835V5.845z"/>
</g>
</g>
</svg>

          </div>
          <img :class="Con1<5?'ImgBig':'ImgMix'" src="../../assets/img/index/bk6.jpg" alt="">
        </div>
      </div>
    </div>


    
    <div class="insuranceCon2 contentWidth"
    v-observe-visibility="handleVisibilityChange"
    v-observe-visibility.once="handleVisibilityChangeOnce"
    id='svgBiaoji' :style="'background-size:'+(100+(historyFirst?8:1)*5)+'% 100%;position:relative;'">
      <div class="insuranceCon21" style="padding-top: 1px;">
        <div class="titleTY">
          <span class="titleTY_top">
            数聚智连发展史
          </span>
          <span class="titleTY_bot">
            HISTORY
          </span>
        </div>
        
        <svg v-show="historyFirst" class="index_sidai_svg" id="index_sidai_svg"   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 792 131.029" style="enable-background:new 0 0 792 131.029;" xml:space="preserve">
          <g>
            <path id="layer1" class="ribbon-layer" style="fill:none;stroke:#0085BF;stroke-width:0.25;stroke-miterlimit:10;" d="M0,130.688   c21.5,0.342,112.744-50.108,212.667-47.021C351.587,87.959,384,78.345,435,65.345c44.944-11.456,103.333-32.678,172-32.178   C637.037,33.385,729,31,792,0"/>
            <path class="ribbon-layer" style="fill:none;stroke:#0086C0;stroke-width:0.25;stroke-miterlimit:10;" d="M0,129.634   c21.671,0.582,113.022-48.372,211.582-45.371c138.066,4.169,170.657-6.284,222.168-19.362   c46.314-11.734,105.458-32.099,174.539-31.055C639.301,34.315,729.959,32.018,792,1.522"/>
            <path class="ribbon-layer" style="fill:none;stroke:#0088C1;stroke-width:0.25;stroke-miterlimit:10;" d="M0,128.581   c21.842,0.823,113.299-46.636,210.496-43.721c137.212,4.045,169.981-7.246,222.004-20.403   c47.684-12.011,107.585-31.503,177.079-29.932C641.567,35.25,730.919,33.036,792,3.044"/>
            <path class="ribbon-layer" style="fill:none;stroke:#008AC2;stroke-width:0.25;stroke-miterlimit:10;" d="M0,127.528   c22.013,1.064,113.577-44.9,209.411-42.07c136.358,3.922,169.305-8.208,221.839-21.443   c49.054-12.289,109.712-30.892,179.618-28.809c32.965,0.982,121.01-1.152,181.132-30.64"/>
            <path class="ribbon-layer" style="fill:none;stroke:#008CC3;stroke-width:0.25;stroke-miterlimit:10;" d="M0,126.475   c22.184,1.305,113.854-43.164,208.326-40.42C343.83,89.853,376.955,76.884,430,63.571c50.424-12.566,111.841-30.266,182.158-27.686   C646.1,37.132,732.838,35.072,792,6.088"/>
            <path class="ribbon-layer" style="fill:none;stroke:#008EC4;stroke-width:0.25;stroke-miterlimit:10;" d="M0,125.422   c22.355,1.546,114.132-41.427,207.241-38.77c134.649,3.675,167.953-10.132,221.509-23.523   c51.794-12.844,113.971-29.627,184.697-26.562C648.368,38.079,733.797,36.09,792,7.61"/>
            <path class="ribbon-layer" style="fill:none;stroke:#0090C5;stroke-width:0.25;stroke-miterlimit:10;" d="M0,124.368   c22.526,1.786,114.409-39.691,206.156-37.12C339.951,90.8,373.433,76.154,427.5,62.685c53.164-13.121,116.1-28.976,187.237-25.439   C650.636,39.03,734.757,37.108,792,9.132"/>
            <path class="ribbon-layer" style="fill:none;stroke:#0092C7;stroke-width:0.25;stroke-miterlimit:10;" d="M0,123.315   c22.697,2.027,114.687-37.955,205.071-35.47c132.941,3.428,166.601-12.056,221.179-25.604   c54.534-13.399,118.23-28.314,189.776-24.316c36.878,2.061,119.69,0.201,175.974-27.272"/>
            <path class="ribbon-layer" style="fill:none;stroke:#0094C8;stroke-width:0.25;stroke-miterlimit:10;" d="M0,122.262   c22.868,2.268,114.965-36.219,203.986-33.82C336.073,91.747,369.911,75.424,425,61.798c55.903-13.676,120.36-27.642,192.316-23.193   c37.856,2.341,119.36,0.539,174.684-26.43"/>
            <path class="ribbon-layer" style="fill:none;stroke:#0097C9;stroke-width:0.25;stroke-miterlimit:10;" d="M0,121.209   c23.039,2.509,115.242-34.483,202.901-32.17C334.133,92.22,368.15,75.059,423.75,61.355c57.273-13.954,122.49-26.96,194.855-22.07   c38.835,2.624,119.03,0.877,173.395-25.588"/>
            <path class="ribbon-layer" style="fill:none;stroke:#0099CA;stroke-width:0.25;stroke-miterlimit:10;" d="M0,120.156   c23.211,2.749,115.52-32.747,201.816-30.519C332.194,92.694,366.389,74.694,422.5,60.912   c58.643-14.231,124.62-26.27,197.395-20.947c39.814,2.912,118.7,1.216,172.105-24.746"/>
            <path class="ribbon-layer" style="fill:none;stroke:#009BCB;stroke-width:0.25;stroke-miterlimit:10;" d="M0,119.103   c23.382,2.99,115.797-31.01,200.731-28.869c129.524,2.934,163.897-15.904,220.519-29.765C481.263,45.96,548,34.897,621.184,40.645   c40.793,3.204,118.37,1.554,170.816-23.904"/>
            <path class="ribbon-layer" style="fill:none;stroke:#1B9ECC;stroke-width:0.25;stroke-miterlimit:10;" d="M0,118.049   c23.553,3.231,116.075-29.274,199.646-27.219C328.316,93.641,362.866,73.964,420,60.025   c61.383-14.786,128.879-24.865,202.474-18.701c41.772,3.499,118.04,1.892,169.526-23.061"/>
            <path class="ribbon-layer" style="fill:none;stroke:#2CA0CD;stroke-width:0.25;stroke-miterlimit:10;" d="M0,116.996   c23.724,3.472,116.352-27.538,198.56-25.569c127.816,2.687,162.545-17.828,220.19-31.845   c62.753-15.063,131.008-24.152,205.013-17.578c42.75,3.798,117.71,2.23,168.237-22.219"/>
            <path class="ribbon-layer" style="fill:none;stroke:#38A3CF;stroke-width:0.25;stroke-miterlimit:10;" d="M0,115.943   c23.895,3.713,116.63-25.802,197.475-23.919c126.962,2.563,161.869-18.79,220.025-32.886   c64.123-15.341,133.136-23.433,207.553-16.454c43.728,4.1,117.38,2.569,166.947-21.377"/>
            <path class="ribbon-layer" style="fill:none;stroke:#42A5D0;stroke-width:0.25;stroke-miterlimit:10;" d="M0,114.89   c24.066,3.953,116.908-24.066,196.39-22.269c126.107,2.44,161.193-19.753,219.86-33.926   c65.493-15.618,135.264-22.707,210.092-15.331c44.706,4.407,117.05,2.907,165.658-20.535"/>
            <path class="ribbon-layer" style="fill:none;stroke:#4AA8D1;stroke-width:0.25;stroke-miterlimit:10;" d="M0,113.837   c24.237,4.194,117.185-22.33,195.305-20.618C320.558,95.534,355.822,72.504,415,58.252   c66.863-15.896,137.391-21.976,212.632-14.208C673.315,48.76,744.351,47.289,792,24.351"/>
            <path class="ribbon-layer" style="fill:none;stroke:#53AAD2;stroke-width:0.25;stroke-miterlimit:10;" d="M0,112.783   c24.408,4.435,117.463-20.593,194.22-18.968c124.399,2.193,159.841-21.677,219.53-36.006   c68.232-16.173,139.517-21.239,215.171-13.085C675.582,49.753,745.311,48.307,792,25.873"/>
            <path class="ribbon-layer" style="fill:none;stroke:#5AADD3;stroke-width:0.25;stroke-miterlimit:10;" d="M0,111.73   c24.579,4.676,117.74-18.857,193.135-17.318C316.68,96.481,352.3,71.773,412.5,57.366c69.602-16.451,141.643-20.498,217.711-11.962   C677.848,50.749,746.27,49.325,792,27.395"/>
            <path class="ribbon-layer" style="fill:none;stroke:#61AFD5;stroke-width:0.25;stroke-miterlimit:10;" d="M0,110.677   c24.75,4.916,118.018-17.121,192.05-15.668c122.691,1.946,158.489-23.601,219.2-38.087c70.972-16.728,143.768-19.752,220.25-10.839   c48.613,5.665,115.729,4.26,160.5-17.167"/>
            <path class="ribbon-layer" style="fill:none;stroke:#68B2D6;stroke-width:0.25;stroke-miterlimit:10;" d="M0,109.624   c24.921,5.157,118.295-15.385,190.965-14.018C312.801,97.428,348.777,71.043,410,56.479   c72.342-17.006,145.893-19.001,222.789-9.716C682.378,52.751,748.189,51.361,792,30.439"/>
            <path class="ribbon-layer" style="fill:none;stroke:#6EB5D7;stroke-width:0.25;stroke-miterlimit:10;" d="M0,108.571   c25.092,5.398,118.573-13.649,189.88-12.368c120.982,1.699,157.136-25.525,218.87-40.167   c73.712-17.283,148.016-18.247,225.329-8.593C684.643,53.757,749.148,52.379,792,31.961"/>
            <path class="ribbon-layer" style="fill:none;stroke:#74B7D8;stroke-width:0.25;stroke-miterlimit:10;" d="M0,107.518   c25.263,5.639,118.851-11.913,188.795-10.718c120.128,1.575,156.46-26.487,218.705-41.207   c75.082-17.561,150.139-17.488,227.868-7.47c51.539,6.643,114.739,5.274,156.632-14.64"/>
            <path class="ribbon-layer" style="fill:none;stroke:#7ABADA;stroke-width:0.25;stroke-miterlimit:10;" d="M0,106.464   c25.434,5.879,119.128-10.176,187.71-9.067c119.274,1.452,155.784-27.449,218.54-42.248   c76.452-17.838,152.261-16.726,230.408-6.347C689.171,55.778,751.067,54.415,792,35.004"/>
            <path class="ribbon-layer" style="fill:none;stroke:#80BDDB;stroke-width:0.25;stroke-miterlimit:10;" d="M0,105.411   c25.605,6.12,119.404-8.306,186.624-7.417C305.041,99.559,341.733,69.583,405,54.706c77.822-18.116,154.383-15.961,232.947-5.223   c53.486,7.31,114.079,5.951,154.053-12.956"/>
            <path class="ribbon-layer" style="fill:none;stroke:#86C0DC;stroke-width:0.25;stroke-miterlimit:10;" d="M0,104.358   c25.776,6.361,119.683-6.704,185.539-5.767c117.566,1.205,154.432-29.373,218.211-44.328c79.191-18.393,156.503-15.193,235.487-4.1   C693.696,57.81,752.986,56.451,792,38.048"/>
            <path class="ribbon-layer" style="fill:none;stroke:#8CC2DE;stroke-width:0.25;stroke-miterlimit:10;" d="M0,103.305   c25.947,6.602,119.961-4.968,184.454-4.117c116.711,1.081,153.756-30.335,218.046-45.368   c80.561-18.67,158.623-14.421,238.026-2.977C695.957,58.831,753.946,57.469,792,39.57"/>
            <path class="ribbon-layer" style="fill:none;stroke:#91C5DF;stroke-width:0.25;stroke-miterlimit:10;" d="M0,102.252   c26.118,6.843,120.238-3.232,183.369-2.467c115.857,0.958,153.08-31.297,217.881-46.409   c81.931-18.948,160.742-13.647,240.566-1.854c56.403,8.333,113.089,6.966,150.184-10.43"/>
            <path class="ribbon-layer" style="fill:none;stroke:#97C8E0;stroke-width:0.25;stroke-miterlimit:10;" d="M0,101.198   c26.289,7.083,120.516-1.496,182.284-0.817C297.287,101.216,334.688,68.123,400,52.933c83.301-19.225,162.86-12.87,243.105-0.731   c57.373,8.679,112.759,7.304,148.895-9.588"/>
            <path class="ribbon-layer" style="fill:none;stroke:#9CCBE1;stroke-width:0.25;stroke-miterlimit:10;" d="M0,100.145   c26.461,7.324,120.794,0.241,181.199,0.833c114.149,0.711,151.728-33.221,217.551-48.489   c84.671-19.503,164.977-12.09,245.645,0.392C702.739,61.91,756.824,60.524,792,44.136"/>
            <path class="ribbon-layer" style="fill:none;stroke:#A1CEE3;stroke-width:0.25;stroke-miterlimit:10;" d="M0,99.092   c26.632,7.565,121.071,1.977,180.114,2.484c113.295,0.587,151.052-34.183,217.386-49.529   c86.041-19.78,167.094-11.308,248.184,1.515c59.313,9.38,112.099,7.98,146.316-7.904"/>
            <path class="ribbon-layer" style="fill:none;stroke:#A6D1E4;stroke-width:0.25;stroke-miterlimit:10;" d="M0,98.039   c26.803,7.806,121.349,3.713,179.029,4.134c112.44,0.463,150.376-35.145,217.221-50.57c87.411-20.058,169.21-10.524,250.724,2.638   C707.256,63.975,758.743,62.56,792,47.18"/>
            <path class="ribbon-layer" style="fill:none;stroke:#ABD4E5;stroke-width:0.25;stroke-miterlimit:10;" d="M0,96.986   c26.974,8.046,121.626,5.449,177.944,5.784C289.53,103.11,327.644,66.663,395,51.16c88.781-20.335,171.325-9.738,253.263,3.761   C709.514,65.012,759.702,63.578,792,48.702"/>
            <path class="ribbon-layer" style="fill:none;stroke:#B0D7E7;stroke-width:0.25;stroke-miterlimit:10;" d="M0,95.933   c27.145,8.287,121.904,7.185,176.859,7.434c110.732,0.216,149.024-37.069,216.891-52.65c90.151-20.613,173.439-8.949,255.803,4.884   c62.218,10.45,111.109,8.995,142.447-5.377"/>
            <path class="ribbon-layer" style="fill:none;stroke:#B5D9E8;stroke-width:0.25;stroke-miterlimit:10;" d="M0,94.879   c27.316,8.528,122.181,8.922,175.774,9.084c109.878,0.093,148.348-38.031,216.726-53.69c91.52-20.89,175.553-8.159,258.342,6.008   C714.027,67.093,761.621,65.614,792,51.746"/>
            <path class="ribbon-layer" style="fill:none;stroke:#BADCE9;stroke-width:0.25;stroke-miterlimit:10;" d="M0,93.826   c27.487,8.769,122.459,10.658,174.688,10.734C283.712,104.53,322.36,65.567,391.25,49.83c92.89-21.168,177.666-7.367,260.882,7.131   C716.283,68.137,762.581,66.632,792,53.268"/>
            <path class="ribbon-layer" style="fill:none;stroke:#BFDFEB;stroke-width:0.25;stroke-miterlimit:10;" d="M0,92.773   c27.658,9.009,122.737,12.394,173.603,12.384C281.773,105.003,320.599,65.202,390,49.387c94.26-21.445,179.754-6.438,263.421,8.254   C718.52,69.288,763.54,67.65,792,54.789"/>
            <path class="ribbon-layer" style="fill:none;stroke:#C3E2EC;stroke-width:0.25;stroke-miterlimit:10;" d="M0,91.72   c27.829,9.25,123.014,14.13,172.518,14.035c107.315-0.278,146.32-40.917,216.232-56.811c95.63-21.723,181.877-5.709,265.961,9.377   C720.783,70.285,764.499,68.668,792,56.311"/>
            <path class="ribbon-layer" style="fill:none;stroke:#C8E5ED;stroke-width:0.25;stroke-miterlimit:10;" d="M0,90.667   c28,9.491,123.292,15.866,171.433,15.685C277.894,105.95,317.077,64.472,387.5,48.5c97-22,183.999-4.98,268.5,10.5   c67.046,12.283,109.459,10.686,136-1.167"/>
          </g>
          </svg>

        <svg v-if="false" v-show="historyFirst" class="index_sidai_svg" id="index_sidai_svg"  xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 792 134.029" style="enable-background:new 0 0 792 134.029;" xml:space="preserve">
          <g>
            <path id="layer1" class="ribbon-layer" style="fill:none;stroke:#359DD1;stroke-width:0.25;stroke-miterlimit:10;" d="M0,75.333   c10.451,13.333,43.295,58,102.266,56.667s166.462-88,232.897-84.667C401.598,50.667,447.133,104,541.934,104S715.114,24.667,792,26   "/> 
            <path class="ribbon-layer" style="fill:none;stroke:#3B9FD2;stroke-width:0.25;stroke-miterlimit:10;" d="M0,73.581   c10.328,13.077,42.962,57.812,101.899,56.738c9.357-0.172,19.929-2.47,31.365-6.213c61.079-19.833,145.281-79.872,201.117-76.122   c24.795,1.756,46.45,10.221,68.894,19.751c37.811,16.111,78.284,35.343,137.851,34.967c9.3-0.063,18.449-0.842,27.457-2.18   C651.038,88.2,722.78,26.748,792,27.923"/>
            <path class="ribbon-layer" style="fill:none;stroke:#40A0D2;stroke-width:0.25;stroke-miterlimit:10;" d="M0,71.829   c10.206,12.821,42.628,57.624,101.532,56.81c9.341-0.133,19.878-2.387,31.296-6.027c61.448-19.593,144.993-78.871,200.772-73.977   c24.909,2.186,46.409,11.06,68.782,20.374c37.548,15.743,78.374,33.146,137.938,32.394c9.316-0.127,18.488-0.924,27.523-2.227   C650.004,87.163,722.918,28.699,792,29.846"/>
            <path class="ribbon-layer" style="fill:none;stroke:#46A2D3;stroke-width:0.25;stroke-miterlimit:10;" d="M0,70.078   c10.083,12.565,42.295,57.436,101.166,56.882c9.325-0.093,19.833-2.289,31.227-5.841c61.84-19.28,144.7-77.761,200.427-71.831   c25.021,2.663,46.369,11.899,68.669,20.997c37.285,15.374,78.465,30.95,138.025,29.822c9.333-0.19,18.528-1.006,27.588-2.275   C648.97,86.127,723.055,30.65,792,31.769"/>
            <path class="ribbon-layer" style="fill:none;stroke:#4AA4D4;stroke-width:0.25;stroke-miterlimit:10;" d="M0,68.326   c9.961,12.309,41.962,57.248,100.799,56.953c9.31-0.054,19.788-2.191,31.158-5.656c62.235-18.965,144.41-76.645,200.081-69.685   c25.135,3.142,46.35,12.682,68.557,21.62c37.058,14.914,78.556,28.754,138.112,27.249c9.35-0.253,18.567-1.087,27.654-2.322   C647.937,85.09,723.193,32.601,792,33.692"/>
            <path class="ribbon-layer" style="fill:none;stroke:#4FA5D5;stroke-width:0.25;stroke-miterlimit:10;" d="M0,66.574   c9.839,12.052,41.629,57.059,100.433,57.025c9.294-0.014,19.743-2.092,31.088-5.47c62.632-18.647,144.122-75.522,199.736-67.539   c25.25,3.624,46.315,13.508,68.445,22.243c36.803,14.525,78.647,26.557,138.199,24.677c9.366-0.316,18.609-1.148,27.719-2.37   C646.928,84.239,723.33,34.552,792,35.615"/>
            <path class="ribbon-layer" style="fill:none;stroke:#53A7D5;stroke-width:0.25;stroke-miterlimit:10;" d="M0,64.822   c9.716,11.796,41.295,56.871,100.066,57.097c9.278,0.025,19.699-1.993,31.019-5.284c63.03-18.327,143.836-74.393,199.391-65.394   c25.366,4.109,46.278,14.335,68.333,22.866c36.546,14.137,78.738,24.361,138.285,22.105c9.383-0.38,18.649-1.226,27.785-2.417   C645.898,83.233,723.467,36.503,792,37.538"/>
            <path class="ribbon-layer" style="fill:none;stroke:#58A9D6;stroke-width:0.25;stroke-miterlimit:10;" d="M0,63.07   c9.594,11.54,40.962,56.683,99.699,57.168c9.262,0.065,19.654-1.893,30.95-5.099C194.078,97.136,274.2,41.882,329.695,51.891   c25.482,4.596,46.242,15.161,68.22,23.489c36.289,13.749,78.829,22.165,138.372,19.532c9.399-0.443,18.688-1.304,27.85-2.465   C644.867,82.225,723.605,38.454,792,39.461"/>
            <path class="ribbon-layer" style="fill:none;stroke:#5CAAD7;stroke-width:0.25;stroke-miterlimit:10;" d="M0,61.318   c9.471,11.284,40.629,56.495,99.333,57.24c9.247,0.104,19.611-1.792,30.881-4.913c63.83-17.677,143.267-72.115,198.7-61.102   c25.599,5.086,46.205,15.989,68.108,24.112c36.031,13.362,78.92,19.968,138.459,16.96c9.416-0.506,18.728-1.383,27.916-2.512   C643.836,81.215,723.742,40.405,792,41.384"/>
            <path class="ribbon-layer" style="fill:none;stroke:#60ACD8;stroke-width:0.25;stroke-miterlimit:10;" d="M0,59.566   c9.349,11.027,40.296,56.307,98.966,57.311c9.231,0.144,19.567-1.69,30.811-4.727c64.233-17.348,142.984-70.967,198.355-58.956   c25.717,5.578,46.168,16.816,67.996,24.735c35.773,12.977,79.011,17.772,138.546,14.387c9.432-0.57,18.768-1.461,27.981-2.56   C642.804,80.203,723.88,42.356,792,43.307"/>
            <path class="ribbon-layer" style="fill:none;stroke:#63ADD8;stroke-width:0.25;stroke-miterlimit:10;" d="M0,57.814   c9.227,10.771,39.962,56.119,98.599,57.383c9.215,0.183,19.524-1.588,30.742-4.542c64.637-17.016,142.701-69.812,198.01-56.811   c25.835,6.073,46.13,17.645,67.883,25.358c35.514,12.592,79.101,15.576,138.632,11.815c9.449-0.633,18.807-1.54,28.047-2.607   C641.772,79.189,724.017,44.307,792,45.23"/>
            <path class="ribbon-layer" style="fill:none;stroke:#67AFD9;stroke-width:0.25;stroke-miterlimit:10;" d="M0,56.062   c9.104,10.515,39.629,55.931,98.233,57.455c9.2,0.223,19.481-1.486,30.673-4.356C193.948,92.48,271.324,40.509,326.57,54.496   c25.953,6.571,46.092,18.473,67.771,25.981c35.254,12.208,79.201,13.499,138.719,9.242c9.467-0.677,18.847-1.619,28.113-2.655   C640.739,78.173,724.154,46.258,792,47.153"/>
            <path class="ribbon-layer" style="fill:none;stroke:#6BB1DA;stroke-width:0.25;stroke-miterlimit:10;" d="M0,54.31   c8.982,10.259,39.296,55.743,97.866,57.526c9.184,0.262,19.438-1.382,30.603-4.17c65.449-16.343,142.136-67.486,197.319-52.519   c26.07,7.071,46.054,19.303,67.659,26.604c34.994,11.825,79.293,11.309,138.806,6.67c9.483-0.739,18.886-1.698,28.178-2.702   c79.275-8.563,163.86-37.51,231.568-36.643"/>
            <path class="ribbon-layer" style="fill:none;stroke:#6EB3DB;stroke-width:0.25;stroke-miterlimit:10;" d="M0,52.558   c8.859,10.003,38.962,55.554,97.499,57.598c9.168,0.302,19.396-1.278,30.534-3.985c65.857-16.002,141.853-66.314,196.974-50.373   c26.188,7.574,46.015,20.133,67.547,27.227c34.733,11.443,79.385,9.119,138.893,4.098c9.5-0.802,18.926-1.778,28.244-2.75   C638.673,76.135,724.429,50.16,792,50.999"/>
            <path class="ribbon-layer" style="fill:none;stroke:#72B4DC;stroke-width:0.25;stroke-miterlimit:10;" d="M0,50.806   c8.737,9.746,38.629,55.366,97.133,57.67c9.152,0.341,19.353-1.173,30.465-3.799C193.864,89.02,269.166,39.54,324.226,56.45   c26.306,8.079,45.976,20.963,67.434,27.85c34.472,11.063,79.477,6.927,138.979,1.525c9.517-0.864,18.965-1.857,28.309-2.797   C637.64,75.114,724.566,52.111,792,52.922"/>
            <path class="ribbon-layer" style="fill:none;stroke:#75B6DC;stroke-width:0.25;stroke-miterlimit:10;" d="M0,49.054   c8.615,9.49,38.296,55.178,96.766,57.741c9.137,0.381,19.311-1.068,30.396-3.613c66.677-15.309,141.284-63.954,196.284-46.082   c26.423,8.586,45.936,21.794,67.322,28.473c34.21,10.683,79.569,4.735,139.066-1.047c9.534-0.927,19.005-1.937,28.375-2.845   C636.606,74.09,724.704,54.062,792,54.845"/>
            <path class="ribbon-layer" style="fill:none;stroke:#79B8DD;stroke-width:0.25;stroke-miterlimit:10;" d="M0,47.302   c8.492,9.234,37.963,54.99,96.399,57.813c9.121,0.42,19.269-0.962,30.326-3.428c67.088-14.958,140.998-62.766,195.938-43.936   c26.54,9.096,45.896,22.626,67.21,29.096c33.947,10.305,79.662,2.543,139.153-3.62c9.55-0.989,19.044-2.017,28.44-2.892   C635.572,73.064,724.841,56.013,792,56.768"/>
            <path class="ribbon-layer" style="fill:none;stroke:#7CBADE;stroke-width:0.25;stroke-miterlimit:10;" d="M0,45.55   c8.37,8.978,37.629,54.802,96.033,57.885c9.105,0.46,19.227-0.856,30.257-3.242C193.791,85.59,267,38.62,321.883,58.403   c26.656,9.608,45.856,23.458,67.097,29.719c33.684,9.928,79.754,0.349,139.24-6.192c9.567-1.052,19.083-2.098,28.506-2.94   C634.537,72.036,724.979,57.964,792,58.691"/>
            <path class="ribbon-layer" style="fill:none;stroke:#80BBDF;stroke-width:0.25;stroke-miterlimit:10;" d="M0,43.798   c8.247,8.722,37.296,54.614,95.666,57.956c9.09,0.499,19.186-0.749,30.188-3.056c67.914-14.245,140.422-60.376,195.248-39.644   c26.771,10.123,45.816,24.291,66.985,30.342c33.42,9.552,79.846-1.845,139.327-8.765c9.584-1.115,19.123-2.178,28.571-2.987   c77.518-6.638,169.131-17.73,236.015-17.03"/>
            <path class="ribbon-layer" style="fill:none;stroke:#83BDE0;stroke-width:0.25;stroke-miterlimit:10;" d="M0,42.047   c8.125,8.465,36.963,54.426,95.299,58.028c9.074,0.539,19.144-0.641,30.119-2.871c68.329-13.883,140.131-59.174,194.903-37.499   c26.885,10.64,45.775,25.125,66.873,30.965c33.156,9.177,79.938-4.04,139.413-11.337c9.601-1.178,19.162-2.259,28.637-3.035   C632.468,69.974,725.253,61.865,792,62.537"/>
            <path class="ribbon-layer" style="fill:none;stroke:#87BFE0;stroke-width:0.25;stroke-miterlimit:10;" d="M0,40.295   c8.003,8.209,36.63,54.238,94.933,58.1c9.058,0.578,19.103-0.532,30.049-2.685c68.744-13.518,139.839-57.968,194.557-35.353   c26.999,11.159,45.734,25.96,66.761,31.588c32.891,8.804,80.03-6.235,139.5-13.909c9.617-1.241,19.201-2.34,28.702-3.082   C631.433,68.941,725.391,63.816,792,64.46"/>
            <path class="ribbon-layer" style="fill:none;stroke:#8AC1E1;stroke-width:0.25;stroke-miterlimit:10;" d="M0,38.543   c7.88,7.953,36.296,54.049,94.566,58.171c9.042,0.618,19.062-0.423,29.98-2.499c69.16-13.149,139.544-56.758,194.212-33.207   c27.111,11.679,45.692,26.795,66.648,32.211c32.626,8.431,80.122-8.431,139.587-16.482c9.634-1.304,19.24-2.421,28.768-3.13   c76.637-5.702,171.767-7.839,238.239-7.224"/>
            <path class="ribbon-layer" style="fill:none;stroke:#8DC3E2;stroke-width:0.25;stroke-miterlimit:10;" d="M0,36.791   c7.758,7.697,35.963,53.861,94.199,58.243c9.027,0.657,19.021-0.314,29.911-2.313c69.577-12.776,139.248-55.543,193.867-31.061   c27.223,12.202,45.651,27.631,66.536,32.834c32.361,8.061,80.213-10.628,139.674-19.054c9.651-1.368,19.279-2.502,28.833-3.177   c76.342-5.393,172.646-4.543,238.98-3.955"/>
            <path class="ribbon-layer" style="fill:none;stroke:#90C4E3;stroke-width:0.25;stroke-miterlimit:10;" d="M0,35.039   c7.635,7.441,35.63,53.673,93.833,58.315c9.011,0.697,18.98-0.204,29.841-2.128C193.668,78.826,262.624,36.9,317.196,62.31   c27.333,12.727,45.609,28.468,66.424,33.457c32.094,7.691,80.305-12.826,139.76-21.627c9.667-1.431,19.319-2.584,28.899-3.225   c76.048-5.087,173.524-1.246,239.721-0.687"/>
            <path class="ribbon-layer" style="fill:none;stroke:#94C6E4;stroke-width:0.25;stroke-miterlimit:10;" d="M0,33.287   c7.513,7.184,35.296,53.485,93.466,58.386c8.995,0.736,18.939-0.093,29.772-1.942c70.412-12.019,138.649-53.104,193.176-26.77   c27.442,13.254,45.567,29.306,66.311,34.08c31.828,7.323,80.396-15.024,139.847-24.199c9.684-1.495,19.358-2.666,28.964-3.272   C627.291,64.787,725.94,71.62,792,72.152"/>
            <path class="ribbon-layer" style="fill:none;stroke:#97C8E4;stroke-width:0.25;stroke-miterlimit:10;" d="M0,31.535   c7.391,6.928,34.963,53.297,93.099,58.458c8.98,0.776,18.898,0.018,29.703-1.756c70.83-11.635,138.345-51.88,192.831-24.624   c27.55,13.782,45.524,30.145,66.199,34.703c31.561,6.957,80.488-17.223,139.934-26.772c9.701-1.558,19.397-2.748,29.03-3.32   c75.459-4.48,175.281,5.347,241.204,5.851"/>
            <path class="ribbon-layer" style="fill:none;stroke:#9ACAE5;stroke-width:0.25;stroke-miterlimit:10;" d="M0,29.783   c7.268,6.672,34.63,53.109,92.733,58.53c8.964,0.815,18.858,0.13,29.634-1.571c71.249-11.247,138.04-50.653,192.486-22.478   c27.657,14.312,45.482,30.985,66.087,35.326c31.294,6.592,80.579-19.422,140.021-29.344c9.717-1.622,19.436-2.83,29.095-3.367   c75.164-4.179,176.16,8.644,241.945,9.12"/>
            <path class="ribbon-layer" style="fill:none;stroke:#9DCCE6;stroke-width:0.25;stroke-miterlimit:10;" d="M0,28.031   c7.146,6.416,34.297,52.921,92.366,58.601c8.948,0.855,18.817,0.243,29.564-1.385c71.669-10.854,137.732-49.422,192.141-20.332   c27.762,14.843,45.439,31.826,65.975,35.949c31.026,6.228,80.67-21.622,140.108-31.916c9.734-1.686,19.475-2.913,29.161-3.415   c74.87-3.88,177.038,11.941,242.686,12.388"/>
            <path class="ribbon-layer" style="fill:none;stroke:#A0CEE7;stroke-width:0.25;stroke-miterlimit:10;" d="M0,26.279   c7.024,6.16,33.963,52.733,91.999,58.673c8.932,0.894,18.777,0.356,29.495-1.199c72.088-10.458,137.421-48.189,191.795-18.187   c27.867,15.376,45.396,32.668,65.862,36.572c30.759,5.866,80.761-23.823,140.194-34.489c9.75-1.75,19.514-2.996,29.226-3.462   C623.148,60.604,726.49,79.424,792,79.844"/>
            <path class="ribbon-layer" style="fill:none;stroke:#A3CFE8;stroke-width:0.25;stroke-miterlimit:10;" d="M0,24.527   c6.901,5.903,33.63,52.545,91.633,58.744c8.917,0.934,18.736,0.469,29.426-1.014c72.508-10.058,137.108-46.954,191.45-16.041   c27.969,15.911,45.353,33.511,65.75,37.195c30.491,5.506,80.852-26.025,140.281-37.061c9.767-1.814,19.554-3.079,29.292-3.51   C622.112,59.553,726.627,81.375,792,81.767"/>
            <path class="ribbon-layer" style="fill:none;stroke:#A6D1E8;stroke-width:0.25;stroke-miterlimit:10;" d="M0,22.775   c6.779,5.647,33.297,52.356,91.266,58.816c8.901,0.973,18.695,0.583,29.357-0.828c72.928-9.653,136.792-45.717,191.105-13.895   c28.071,16.447,45.309,34.356,65.638,37.818c30.223,5.147,80.943-28.227,140.368-39.634c9.783-1.878,19.593-3.162,29.357-3.557   C621.076,58.501,726.764,83.326,792,83.69"/>
            <path class="ribbon-layer" style="fill:none;stroke:#A9D3E9;stroke-width:0.25;stroke-miterlimit:10;" d="M0,21.023   c6.656,5.391,32.964,52.168,90.9,58.888c8.885,1.013,18.655,0.698,29.287-0.642c73.349-9.245,136.474-44.477,190.76-11.749   c28.171,16.984,45.266,35.201,65.525,38.441c29.954,4.79,81.01-30.547,140.455-42.206c9.796-1.962,19.632-3.246,29.423-3.605   C620.041,57.447,726.902,85.277,792,85.613"/>
            <path class="ribbon-layer" style="fill:none;stroke:#ACD5EA;stroke-width:0.25;stroke-miterlimit:10;" d="M0,19.271   c6.534,5.135,32.63,51.98,90.533,58.959c8.869,1.052,18.614,0.813,29.218-0.457c73.769-8.832,136.153-43.235,190.414-9.604   c28.269,17.522,45.222,36.047,65.413,39.064c29.686,4.435,81.101-32.744,140.542-44.778c9.812-2.025,19.671-3.33,29.488-3.652   C619.005,56.392,727.039,87.228,792,87.536"/>
            <path class="ribbon-layer" style="fill:none;stroke:#AFD7EB;stroke-width:0.25;stroke-miterlimit:10;" d="M0,17.519   c6.412,4.879,32.297,51.792,90.166,59.031c8.854,1.092,18.574,0.928,29.149-0.271c74.19-8.415,135.83-41.992,190.069-7.458   c28.366,18.061,45.179,36.895,65.301,39.687c29.418,4.081,81.192-34.94,140.628-47.351c9.829-2.088,19.71-3.414,29.554-3.7   C617.969,55.334,727.177,89.179,792,89.459"/>
            <path class="ribbon-layer" style="fill:none;stroke:#B2D9EC;stroke-width:0.25;stroke-miterlimit:10;" d="M0,15.767   C6.289,20.39,31.964,67.371,89.8,74.87c8.838,1.131,18.533,1.045,29.079-0.085c74.61-7.993,135.504-40.747,189.724-5.312   c28.462,18.601,45.135,37.744,65.189,40.31c29.15,3.729,81.282-37.136,140.715-49.923c9.845-2.152,19.749-3.498,29.619-3.747   C616.934,54.275,727.314,91.13,792,91.382"/>
            <path class="ribbon-layer" style="fill:none;stroke:#B5DBEC;stroke-width:0.25;stroke-miterlimit:10;" d="M0,14.016   c6.167,4.366,31.63,51.416,89.433,59.174c8.822,1.171,18.492,1.161,29.01,0.1c75.03-7.567,135.176-39.501,189.378-3.166   c28.556,19.143,45.092,38.595,65.076,40.933c28.882,3.379,81.373-39.333,140.802-52.496c9.862-2.215,19.789-3.583,29.685-3.795   C615.898,53.214,727.451,93.081,792,93.305"/>
            <path class="ribbon-layer" style="fill:none;stroke:#B7DCED;stroke-width:0.25;stroke-miterlimit:10;" d="M0,12.264   c6.044,4.11,31.297,51.228,89.066,59.246c8.807,1.21,18.452,1.278,28.941,0.286c75.45-7.137,134.845-38.253,189.033-1.02   c28.649,19.685,45.049,39.447,64.964,41.556c28.614,3.03,81.464-41.529,140.889-55.068c9.878-2.278,19.828-3.668,29.751-3.842   C614.863,52.151,727.589,95.032,792,95.228"/>
            <path class="ribbon-layer" style="fill:none;stroke:#BADEEE;stroke-width:0.25;stroke-miterlimit:10;" d="M0,10.512   c5.922,3.854,30.964,51.04,88.7,59.318c8.791,1.25,18.411,1.396,28.872,0.472c75.87-6.702,134.511-37.004,188.688,1.125   c28.741,20.228,45.006,40.3,64.852,42.179c28.346,2.684,81.555-43.725,140.975-57.641c9.895-2.341,19.867-3.753,29.816-3.89   C613.828,51.087,727.726,96.983,792,97.151"/>
            <path class="ribbon-layer" style="fill:none;stroke:#BDE0EF;stroke-width:0.25;stroke-miterlimit:10;" d="M0,8.76c5.8,3.598,30.631,50.851,88.333,59.389   c8.775,1.289,18.37,1.514,28.802,0.657c76.289-6.263,134.175-35.755,188.343,3.271c28.831,20.772,44.963,41.154,64.739,42.802   c28.078,2.339,81.646-45.922,141.062-60.213c9.912-2.405,19.906-3.839,29.882-3.937C612.793,50.021,727.864,98.934,792,99.074"/>
            <path class="ribbon-layer" style="fill:none;stroke:#C0E2F0;stroke-width:0.25;stroke-miterlimit:10;" d="M0,7.008   c5.677,3.341,30.297,50.663,87.966,59.461c8.759,1.329,18.329,1.632,28.733,0.843c76.708-5.82,133.837-34.504,187.997,5.417   c28.92,21.316,44.92,42.011,64.627,43.425c27.811,1.996,81.737-48.118,141.149-62.785c9.928-2.468,19.945-3.944,29.947-3.985   c71.338-0.57,187.581,51.502,251.58,51.613"/>
            <path class="ribbon-layer" style="fill:none;stroke:#C2E4F0;stroke-width:0.25;stroke-miterlimit:10;" d="M0,5.256   c5.555,3.085,29.964,50.475,87.6,59.533c8.744,1.368,18.288,1.751,28.664,1.029c77.127-5.372,133.496-33.252,187.652,7.563   c29.007,21.861,44.877,42.868,64.515,44.048c27.545,1.654,81.828-50.314,141.236-65.358c9.945-2.531,19.985-4.026,30.013-4.032   c71.045-0.261,188.46,54.798,252.321,54.882"/>
            <path class="ribbon-layer" style="fill:none;stroke:#C5E6F1;stroke-width:0.25;stroke-miterlimit:10;" d="M0,3.504   c5.432,2.829,29.631,50.287,87.233,59.604c8.728,1.408,18.247,1.871,28.595,1.214c77.545-4.919,133.071-31.892,187.307,9.708   c29.049,22.465,44.835,43.727,64.402,44.671c27.279,1.315,81.919-52.511,141.323-67.93c9.961-2.595,20.024-4.108,30.078-4.08   C609.69,46.74,728.276,104.787,792,104.843"/>
            <path class="ribbon-layer" style="fill:none;stroke:#C8E7F2;stroke-width:0.25;stroke-miterlimit:10;" d="M0,1.752   c5.31,2.573,29.298,50.099,86.866,59.676c8.712,1.447,18.206,2.002,28.525,1.4c77.967-4.377,132.765-30.693,186.962,11.854   c29.155,22.982,44.793,44.612,64.29,45.294c27.012,1.01,82.009-54.707,141.409-70.503c9.978-2.658,20.064-4.189,30.144-4.127   c70.46,0.357,190.217,61.392,253.804,61.42"/>
            <path class="ribbon-layer" style="fill:none;stroke:#CBE9F2;stroke-width:0.25;stroke-miterlimit:10;" d="M0,0c5.972,2.667,36.577,65.333,114.956,61.333   s132.46-29.493,186.616,14c29.261,23.5,44.752,45.45,64.178,45.917C397,122,467.287,43.333,537.455,44S728.55,108.688,792,108.688"/>
          </g>
        </svg>
        


      </div>
    </div>
    
    <!-- 主体公司介绍 -->

    
    <div class="zhutijieshao" id="zhutijieshao">
      <div class="zhutijieshao contentWidth" style="padding-top:1px;">
        <!-- <div class="receivingPrizes" :style="'opacity:'+(Con4==0?'0':'1')" data-aos=""  data-aos-duration="1200">
          <span class="receivingPrizes1">
            MAIN COMPANIES
          </span><br>
          <span class="receivingPrizes2">
            主体公司介绍
          </span>
          <span class="receivingPrizes3" >
          </span>
        </div> -->
        
    <div class="titleTY">
      <span class="titleTY_top">
        主体公司介绍
      </span>
      <span class="titleTY_bot">
        MAIN COMPANIES
      </span>
    </div>



        <div class="zhutiSend">
          <div v-for="i in zhuti">
            <div class="zhutiSendImgDiv">
              <img :src="i.img" style="margin-bottom:10px;"/>
            </div>
            <!-- <h3>{{i.name}}</h3> -->
            <span>{{i.name}}{{i.content}}</span>
          </div>
        </div>
      </div>

      
    </div>

    <!-- 主体公司介绍结束 -->
    <div class="insuranceCon3" id="insuranceCon3" v-if="false">
      <div class="insuranceCon31 contentWidth" style="padding-top:1px;">
        <!-- <div class="receivingPrizes" :style="'opacity:'+(Con3==0?'0':'1')" data-aos=""  data-aos-duration="1200">
          <span class="receivingPrizes1">
            RECEIVING PRIZES
          </span><br>
          <span class="receivingPrizes2">
            所获奖项
          </span>
          <span class="receivingPrizes3">

          </span>
        </div> -->
        
    <div class="titleTY">
      <span class="titleTY_top">
        所获奖项
      </span>
      <span class="titleTY_bot">
        RECEIVING PRIZES
      </span>
    </div>

        <!-- <div class="insuranceCon32 contentWidth">
          <div class="con32KP" :style="'left:'+(40+110*(Con3)*0.25)+'px;top:'+0+'px;z-index:2;'">
            <div v-for="i in con32KP2" :style="'opacity:'+(Con3>1?'1':'0')">
              <span>{{i.title}}</span><br>
              <span>{{i.s}}</span>
            </div>
          </div>
          <div class="con32KP" :style="'left:'+(100+550*(Con3)*0.25)+'px;top:'+(-40+40*(Con3)*0.25)+'px;z-index:1;'">
            <div v-for="i in con32KP1" :style="'opacity:'+(Con3>2?'1':'0')">
              <span>{{i.title}}</span><br>
              <span>{{i.s}}</span>
            </div>
          </div>
        </div> -->


        <div class="insuranceCon32 contentWidth" v-if='false'> 
        
          <swiper :options="swiperOption2" ref="mySwipe1r2">
            <swiper-slide v-for="(i,index) in con32KP1" :key='index'>
              <div class="luoBI">
                <img :src="i.img">
                <span>{{i.title}}</span><br>
                <span style="font-size:12px;line-height:20px;color:#80888f;" v-html="i.s"></span>
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev" style="left:-20px;"></div><!--左箭头。如果放置在swiper-container外面，需要自定义样式。-->
          <div class="swiper-button-next"></div><!--右箭头。如果放置在swiper-container外面，需要自定义样式。-->
        </div>


      </div>
      
    </div>
  </div>
</template>

<script>
import ZSelect from '../modules/Zselect'
export default {
  name: 'insurance',
  components:{ZSelect},
  data () {
    return {
      bannerImg:[
        // require('../../assets/img/index/banner1.jpg'),
        require('../../assets/img/index/banner2.jpg'),
        //临时的一张banner图 
        require('../../assets/img/index/banner3ls.jpg'),
        require('../../assets/img/index/banner5ls.jpg'),
        // require('../../assets/img/index/banner3.jpg'),
        // require('../../assets/img/index/banner5.jpg'),

        // require('../../assets/img/index/banner1111.png'),
        // require('../../assets/img/index/banner202001.png'),
        // require('../../assets/img/index/banner202002.png'),
        // require('../../assets/img/index/banner2019133.jpg'),
        // // require('../../assets/img/index/banner202003.png'),
        // require('../../assets/img/index/banner2019131.jpg'),
        // require('../../assets/img/index/banner1.jpg'),
        // require('../../assets/img/index/banner2.jpg'),
        // require('../../assets/img/index/banner3.jpg'),
        // require('../../assets/img/index/banner4.jpg'),
      ],
      shubiaozaiswipershang:false,
      zhuti:[
        {
          img:require('../../assets/img/index/sjzl.png'),
          name:'数聚智连',
          content:'旗下包括东连科技，北联伟业，亚加科技等子公司，是中国主流电商平台领先的整合型电商服务商。公司聚焦营养健康，美妆个护和消费电子等品类，服务超过50+全球知名品牌。公司长期荣获天猫五星，天猫国际金星，京东京卓越，抖音KA等中国主流电商平台认证，提供包括电商运营，供应链，流量运营和消费者运营等在内的全链路电商运营。',
        },
        {
          img:require('../../assets/img/index/llyx.png'),
          name:'榴莲营销',
          content:'是一家以品牌增长为使命的数字营销机构，帮助行业、品牌和用户实现增长。机构将传统数字营销与电商销售进行整合，为客户实现品效一体的营销结果。公司服务包括产业公关、种草、电商营销、流量运营等，服务数十家国内外知名品牌。',
        },
        // {
        //   img:require('../../assets/img/index/dl.png'),
        //   name:'东连科技',
        //   content:'东连是数聚智连旗下专注京东平台业务的子公司，服务范围从店铺运营，视觉设计，内容运营等全运营，再到效果营销，无界零售等品牌营销领域，目前在京东服务品牌数量20+，总GMV50亿以上。',
        // },
        // {
        //   img:require('../../assets/img/index/cys.png'),
        //   name:'畅益思',
        //   content:'专注零售市场服务，涵盖零售终端SI设计，店面设计和装修，POSM设计和制作，销售人员管理，终端活动策划及新零售场景营销。',
        // },
        {
          img:require('../../assets/img/index/SJCFLogo.png'),
          // name:'数聚宸飞',
          content:'数聚智连旗下专注于跨境出海的电商公司，立志帮助国内商品实现全球销售，聚焦母婴玩具、3C电子和智能宠物等品类，覆盖欧洲、北美、澳洲等区域和亚马逊、Tiktok等海外电商平台，实现中国造，卖全球。',
        }
      ],
      test1:'1',
      test2:'1',
      
      swiperOption2:{
        // 一行显示slider的个数
        slidesPerView: 3,
      
          // 定义slides的数量多少为一组
        slidesPerGroup: 1,
        // navigation:{
        //   nextButton:'.swiper-button-next',//绑定下一页的控制按钮
        //   prevButton:'.swiper-button-prev',//绑定上一页的控制按钮,

        // },
        navigation: {

        nextEl: ".swiper-button-next", //前进按钮的css选择器或HTML元素。

        prevEl: ".swiper-button-prev", //后退按钮的css选择器或HTML元素。

        hideOnClick: true, //点击slide时显示/隐藏按钮

        disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。

        hiddenClass: "my-button-hidden" //按钮隐藏时的Class

        },

        loop:false,
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000
        },
        observer:true,
        speed:300,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },
      
      swiperOption:{
        loop:true,
        effect:'fade',
        notNextTick: true,
        mousewheelControl: true,
        autoplayDisableOnInteraction:false,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        autoplay : {
          delay:4000
        },
        observer:true,
        speed:1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
      },

      Con2Text:[
        {
          title:'2007',
          h:['北联伟业成立 博思瀚扬成立'],
        },
        {
          title:'2010',
          h:['北联伟业成为阿里第一批TP'],
        },
        {
          title:'2012',
          // h:['北联伟业成为阿里TP','KA服务商'],
          h:['北联伟业成为阿里TP KA服务商'],
        },
        {
          title:'2015',
          h:['整合成立为蓝标电商'],
        },
        {
          title:'2016',
          h:['挂牌新三板  '],
          // s:'（股票代码：300058）'
        },
        {
          title:'2018',
          h:['战略升级，更名为“北京数聚智连科技股份有限公司”，开启中国领先的品牌爆发引擎的服务理念'],
        },
        {
          title:'2022',
          h:['数聚智连深圳交易所创业板首发申请获批'],
        },
        {
          title:'2024',
          h:['数聚宸飞成立，启动跨境出海战略'],
        },
      ],
      Con2:0,
      Con1:0,
      Con3:0,
      Con4:0,
      ImgHover:0,
      con32KP1:[
        {
          img:require('../../assets/img/index/20260921001.jpg'),
          title:'行业趋势孵化奖&超级v-partner-店铺运营',
          news:'news20260921'
        },
        {
          img:require('../../assets/img/index/20260520001.jpg'),
          title:'天猫国际金星服务商&餐线行业银星服务商',
          news:'news20260520'
        },
        {
          img:require('../../assets/img/index/20260429001.jpg'),
          title:'四年蝉联“铁冬青”',
          news:'news20260429'
        },
        {
          img:require('../../assets/img/index/20260424001.jpg'),
          title:'七年蝉联“京卓越”',
          news:'news20260424'
        },
        {
          img:require('../../assets/img/index/20260327001.jpg'),
          title:'天猫五星',
          news:'news20260327'
        },
        {
          img:require('../../assets/img/index/20260305001.jpg'),
          title:'天猫生态快消行业认证',
          news:'news20260305'
          // 2022年度
        },
        {
          img:require('../../assets/img/index/20250507001.jpg'),
          title:'京东健康最佳代运营服务商',
          news:'news20250507'
          // 2022年度
        },
        {
          img:require('../../assets/img/index/20250327002.jpg'),
          title:'高新技术企业证书',
          news:'news20250327'
          // 2024年
        },
        {
          img:require('../../assets/img/index/20250320001.jpg'),
          title:'北京服务业企业百强',
          news:'news2'
          // 2024年
        },
        {
          img:require('../../assets/img/index/20250320002.jpg'),
          title:'“中关村高新技术企业”认证',
          news:'news0'
          // 2025年
        },
        {
          img:require('../../assets/img/index/20250320006.jpg'),
          title:'天猫五星与天猫国际金星',
          news:'news27'
        },
        {
          img:require('../../assets/img/index/20250320003.jpg'),
          img:require('../../assets/img/index/20250401001.jpg'),
          title:'京东“京卓越”最佳代运营服务商',
          news:'news20250401'
          // 2023年度
        },
        // {
        //   img:require('../../assets/img/index/20250320004.jpg'),
        //   title:'京东健康最佳代运营服务商',
        //   news:'news10'
        //   // 2022年度
        // },
        {
          img:require('../../assets/img/index/20250320007.jpg'),
          title:'京东美妆“最佳合作伙伴奖”',
          news:'news19'
        },
        {
          img:require('../../assets/img/index/20250320005.jpg'),
          title:'抖音电商品牌服务商认证',
          news:'news12'
        },
        {
          img:require('../../assets/img/index/20250320008.jpg'),
          title:'TBI杰出品牌创新奖三项金奖',
          news:'news1'
        },
        {
          img:require('../../assets/img/index/20250327001.jpg'),
          title:'第十五届“金投赏”商业创意奖',
          news:'news20250326'
        },
        {
          img:require('../../assets/img/index/202217.jpg'),
          title:'大中华区艾菲效果营销奖专项金奖',
          news:'news15'
          // 2022年度
        },
        

        // {
        //   img:require('../../assets/img/index/202501.jpg'),
        //   title:'“中关村高新技术企业”认证',
        //   // 2025年
        // },
        // {
        //   img:require('../../assets/img/index/202412.jpg'),
        //   title:'北京服务业企业百强',
        //   // 2024年
        // },

        // {
        //   img:require('../../assets/img/index/202401.jpg'),
        //   title:'2023年度“京卓越”代运营服务商奖',
        // },
        // {
        //   img:require('../../assets/img/index/202305.jpg'),
        //   title:'第14届金鼠标“数字营销最具创新精神品牌”奖',
        // },
        // {
        //   img:require('../../assets/img/index/202304.jpg'),
        //   title:'2022年度卓越代运营服务商“铁冬青”奖',
        // },
        // {
        //   img:require('../../assets/img/index/202303.jpg'),
        //   title:'m awards年度新品打爆增长奖',
        // },
        // {
        //   img:require('../../assets/img/index/202302.jpg'),
        //   title:'抖音电商品牌服务商认证',
        // },
      
        // {
        //   img:require('../../assets/img/index/202301.jpg'),
        //   title:'2022年度“京卓越”代运营服务商奖',
        // },
      
        // {
        //   img:require('../../assets/img/index/202217.jpg'),
        //   title:'2022年度大中华区艾菲效果营销奖专项金奖',
        // },
        // {
        //   img:require('../../assets/img/index/202216.jpg'),
        //   title:'年度母婴TP服务商杰出表现大奖',
        // },
        // {
        //   img:require('../../assets/img/index/202215.jpg'),
        //   title:'2022年度TBI杰出品牌创新奖',
        // },
        // {
        //   img:require('../../assets/img/index/202201.jpg'),
        //   title:'京东美妆“最佳合作伙伴奖”',
        // },
        // {
        //   img:require('../../assets/img/index/202202.jpg'),
        //   title:'2022年·第4季度天猫星级服务商',
        // },
        // {
        //   img:require('../../assets/img/index/202204.jpg'),
        //   title:'2022年·第10届Topdigital创新营销奖',
        // },
        // {
        //   img:require('../../assets/img/index/202205.jpg'),
        //   title:'2022年·第22届IAI传鉴国际广告奖',
        // },
        // {
        //   img:require('../../assets/img/index/202206.jpg'),
        //   title:'2022年·京赢未来效果营销赛道金奖',
        // },
        // {
        //   img:require('../../assets/img/index/202207.jpg'),
        //   title:'2022 M awards年度货品经营｜优胜奖',
        // },
        // {
        //   img:require('../../assets/img/index/202208.jpg'),
        //   title:'京东代运营服务年度奖项·“京卓越”奖',
        // },
        // {
        //   img:require('../../assets/img/index/202209.jpg'),
        //   title:'天猫国际金星服务商',
        // },
        // {
        //   img:require('../../assets/img/index/202210.jpg'),
        //   title:'第8届TMA移动营销大奖',
        // },
        // {
        //   img:require('../../assets/img/index/202212.jpg'),
        //   title:'第八届蒲公英盛典·一金二银',
        // },
        // {
        //   img:require('../../assets/img/index/202213.jpg'),
        //   title:'第十四届“金投赏”商业创意奖',
        // },
        // {
        //   img:require('../../assets/img/index/202214.jpg'),
        //   title:'数聚智连喜获第十五届金投赏三个奖项',
        // },
        // 2025年3月20日注释了上面内容、


        
      //   {
      //     img:require('../../assets/img/index/13.jpg'),
      //     title:'母婴行业第一名',
      //   },
      //   {
      //     img:require('../../assets/img/index/11.jpg'),
      //     title:'五芳斋“与粽不同”天猫超级品牌日',
      //     s:'天猫服务商优秀案例',
      //   },
      //   {
      //     img:require('../../assets/img/index/12.jpg'),
      //     title:'西铁城时光开黑局',
      //     s:'第十一届金网奖时尚行业类别金奖<br/>天猫服务商优秀案例',
      //   },
      //   {
      //     img:require('../../assets/img/index/1.jpg'),
      //     title:'Oral-B星际洁齿',
      //     s:'第11届金投赏国际创意节金投赏奖；第25届中国国际广告节媒介营销金奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/2.jpg'),
      //     title:'舒肤佳 舒服家',
      //     s:'艾菲奖金奖、中国广告长城奖金奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/3.jpg'),
      //     title:'方便面3.0：方便不随便',
      //     s:'第11届金投赏国际创意节 金投赏奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/4.jpg'),
      //     title:'京东空气餐厅',
      //     s:'第25届中国国际广告节互动创意奖、媒介营销奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/5.jpg'),
      //     title:'牙不白，怎么红',
      //     s:'第25届中国国际广告节互动创意奖',
      //   },
      //   {
      //     img:require('../../assets/img/index/6.jpg'),
      //     title:'放粽吧宝贝',
      //     s:'第25届中国国际广告节媒介营销奖',
      //   },
      // // ],
      // // con32KP2:[
      //   {
      //     img:require('../../assets/img/index/9.jpg'),
      //     title:'Tampax Launch Campaign',
      //   },
      //   {
      //     img:require('../../assets/img/index/10.jpg'),
      //     title:'Movefree天猫超级品牌日',
      //   },
      //   {
      //     img:require('../../assets/img/index/8.jpg'),
      //     title:'Oral-B发现新星图',
      //   },
      //   {
      //     img:require('../../assets/img/index/7.jpg'),
      //     title:'iBrush Plus黑科技邀请函',
      //   },
      ],
      
      swiperOption3:{
        observer: true,         // 监控自身 DOM 变化
        observeParents: true,  // 监控父容器 DOM 变化
        // 一行显示slider的个数
        slidesPerView: 5,
        spaceBetween:10,//轮播之间的间距
          // 定义slides的数量多少为一组
        slidesPerGroup: 1,
        
        
        navigation: {

          nextEl: ".swiper_button_next_new", //前进按钮的css选择器或HTML元素。

          prevEl: ".swiper_button_prev_new", //后退按钮的css选择器或HTML元素。

          hideOnClick: true, //点击slide时显示/隐藏按钮

          disabledClass: "my-button-disabled", //前进后退按钮不可用时的类名。

          hiddenClass: "my-button-hidden" //按钮隐藏时的Class

        },
        centeredSlides: false,
        
        loop:true,
        notNextTick: true,
        mousewheelControl: true,
        // autoplayDisableOnInteraction:true,//人为干预以后不在滚动
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        paginationClickable: true,
        
        autoplay : {
          delay:3000,
          disableOnInteraction: false // 用户交互后继续自动播放
        },
        
        delay:10000,
        
        speed:1000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        

      },
      historyFirst:false,
    }
  },
  methods: {
    LinkNews(data){
      this.$router.push({path:'/news',query:{'data':data.news}})
      console.log(data)
    },
    names(data) {
      console.log(data)
    },
    ImgMouse(data){
      this.ImgHover = data;
    },
    handleVisibilityChange(isVisible, entry) {
    },
    handleVisibilityChangeOnce(isVisible) {
      this.historyFirst = isVisible
      setTimeout(() => {
        this.historyFn()
      }, 0);
    },
    historyFn(){
        var that = this;
        function createSmartMarkers(msg) {
              // 清空旧标记
              document.querySelectorAll('.path-marker').forEach(m => m.remove());
              // 获取窗口宽度外的留白
              const segmentCount = that.Con2Text.length;
              var liubai = 0.11;
              var jianju = 0;
              if(false && window.innerWidth>1200){
                liubai = ((window.innerWidth - 1200)*0.5)/window.innerWidth+0.02;
                jianju = 1200
              }
              const svg = document.getElementById('index_sidai_svg');
              const path = document.getElementById('layer1');
              const totalLength = path.getTotalLength();
              const startPosition = totalLength * liubai; // 从50%位置开始
              
              // 创建标记点
              for(let i = 0; i <= segmentCount; i++) {
                // 计算路径位置（50%-100%之间）
                // 其中这个liubai*1.6是间距
                const pos = startPosition + (totalLength * (1-liubai*1.6)) * (i / segmentCount);
                
                // 获取SVG坐标点
                const svgPoint = path.getPointAtLength(pos);
                // 转换为页面坐标
                const svgRect = svg.getBoundingClientRect();
                
                // const pageX = svgPoint.x * (svgRect.width / svg.viewBox.baseVal.width) + svgRect.left;
                const pageX = svgPoint.x * (svgRect.width / svg.viewBox.baseVal.width);
                // const pageY = svgPoint.y * (svgRect.height / svg.viewBox.baseVal.height) + svgRect.top;
                const pageY = svgPoint.y * (svgRect.height / svg.viewBox.baseVal.height) + 220;

                var yanchi = 0
                if(msg=='noe'){
                  yanchi=1
                }else{
                  yanchi=0
                }
                // 创建DIV元素
                const marker = document.createElement('div');
                marker.className = 'path-marker';
                Object.assign(marker.style, {
                  left: `${pageX}px`,
                  top: `${pageY}px`,
                  animationDelay: `${yanchi+i * 0.3}s`
                });
                const wenan = document.createElement('div');
                wenan.className = 'path-wenan';

                const h2 = document.createElement('h2');
                h2.innerHTML = that.Con2Text[i].title;
                wenan.appendChild(h2);
                for(var j = 0; j < that.Con2Text[i].h.length; j++){
                  const span = document.createElement('span');
                  span.innerHTML = that.Con2Text[i].h[j];
                  wenan.appendChild(span);
                }


                

                // 添加悬浮提示
                // marker.title = `位置：${((pos / totalLength) * 100).toFixed(1)}%`;

                const container = document.getElementById('svgBiaoji');

                marker.appendChild(wenan);
                container.appendChild(marker);
              }
        }

        // 响应式更新
        // window.addEventListener('resize', createSmartMarkers);
        createSmartMarkers('noe');
    },
    playSwiper(){
      // 启动自动播放
      this.$refs.mySwipe1New.swiper.autoplay.start();
      this.shubiaozaiswipershang = false
    },
    stopSwiper(){
      // 立即停止自动播放
      this.$refs.mySwipe1New.swiper.autoplay.stop();
      this.shubiaozaiswipershang = true
    }
  },
  mounted(){
    var that = this
    // 正确委托到 .swiper-wrapper
    document.querySelector('.swiper-wrapper').addEventListener('click', (e) => {
      const slide = e.target.closest('.swiper-slide');
      if (slide) {
        var index = slide.getAttribute('data-swiper-slide-index')
        
        that.LinkNews(that.con32KP1[index])
      }
    });

    // 立即停止自动播放
    this.$refs.mySwipe1New.swiper.autoplay.stop();

    // 5秒后启动自动播放
    setTimeout(() => {
      if(!this.shubiaozaiswipershang){
        this.$refs.mySwipe1New.swiper.autoplay.start();
      }
    }, 5000);

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less"> 
.insurance{
  .insuranceCon12To{
    svg{
      width:60%;
      position: absolute;
      margin: auto;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
    }
    path,rect {
        stroke-dasharray: 140;
        stroke-dashoffset: 0;
        /* animation: dash 3s linear infinite; */
        animation: dash 1.5s linear 1;
        animation-fill-mode: forwards;
        /* 填充的透明度 */
        fill-opacity:0;
        /* 描边宽度 */
        stroke-width:0.7;
        /* 描边画笔是圆头 */
        stroke-linecap:'round';
        /* 描边画笔拐角是圆头 */
        stroke-linejoin:'round';
    }
  }
  @keyframes dash {
      0% {
          stroke-dashoffset: 140;
      }
      30% {
          fill-opacity:0;
          stroke-width:0.7;
      }
      100% {
          stroke-dashoffset: 0;
          stroke-width:0.0;
          fill-opacity:1;
      }
  }
  .buged{
    border-top: 1px solid transparent;
    position: relative;
  }
  .luoBI{
    display: inline-block;
    width: 350px;
    height: 200px;
    overflow: hidden;
    margin: 10px;
    box-shadow:0 0px 6px rgba(0,0,0,.1) ;
    border-radius: 10px;
    img{
      width: 100%;
    }
    span{
      font-size: 16px;
      display: block;
      line-height: 50px;
      text-align: center;
      color: #80888f;
    }
  }
  .ceshi{
    display: inline-block;
    width: 7rem;
    height: 3rem;
  }
  .swiperImg{
    width: 100%;
    min-width: 1200px;
    height: auto;
  }
  /*第一屏*/
  .insuranceCon1{
    .insuranceCon12{
      height: 580px;
      margin-bottom: 80px;
    }
    
    .insuranceCon12>.insuranceCon12To{
      display: inline-block;
      font-size: 0;
      overflow: hidden;
      height: 290px;
      width: 25%;
      float: left;
      position: relative;
      img{
        display: block;
        margin: 0;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        position: absolute;
        left: 0;
        top:0;
        z-index: 1;
      }
      .insuranceCon12Zhe{
        display: inline-block;
        width: 100%;
        height: 100%;
        opacity: 0;
        position: absolute;
        left: 0;
        top:0;
        background: rgba(0,104,183,0.8);
        z-index: 2;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        span{
          display: inline-block;
          width: 80px;
          height: 80px;
          background: url('../../assets/img/index/add.png') no-repeat center;
          background-size: cover;
          position: absolute;
          top: 20px;
          left: 20px;
          transition: all 1s ease-out;
          -moz-transition: all 1s ease-out;	/* Firefox 4 */
          -webkit-transition: all 1s ease-out;	/* Safari 和 Chrome */
          -o-transition: all 1s ease-out;	/* Opera */
        }
        img{
          position: absolute;
          top:0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 50%;
        }
      }
    }
    .ImgBig{
      transform:scale(1.2);
      -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
    }
    .ImgMix{
      transform:scale(1);
      -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
    }
    .insuranceCon12>div:nth-of-type(1){
      width: 50%;
    }
    .insuranceCon12>div:nth-of-type(5){
      width: 50%;
    }
    .insuranceCon11{
      height: 87px;
      background: #fff;
      .insuranceCon11_right,.insuranceCon11_left{
        display: inline-block;
        height: 100%;
        width: 50%;
        float: left;
        border: none;
        
      }
    }
    .insuranceCon11::after{
      display: inline-block;
      overflow: hidden;
      clear: both;
      content: '';
    }
    .insuranceCon11_left{
      position: relative;
      img{
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        margin: auto;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        width: 12%;
        animation: insuran11SF 5s;
        -moz-animation: insuran11SF 5s;	/* Firefox */
        -webkit-animation: insuran11SF 5s;	/* Safari 和 Chrome */
        -o-animation: insuran11SF 5s;	/* Opera */
      }
      @keyframes insuran11SF
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-moz-keyframes insuran11SF /* Firefox */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-webkit-keyframes insuran11SF /* Safari 和 Chrome */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }

      @-o-keyframes insuran11SF /* Opera */
      {
        from {
        transform:scale(1.2);
        -webkit-transform:scale(1.2);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1.2);     /*兼容-moz-引擎浏览器*/
        }
        to {
        transform:scale(1);
        -webkit-transform:scale(1);  /*兼容-webkit-引擎浏览器*/
        -moz-transform:scale(1);     /*兼容-moz-引擎浏览器*/
        }
      }
      .insuranceAbout{
        display: inline-block;
        width: 190px;
        height: 100px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        font-size: 38px;
        color: #80888f;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        animation: swiperRc 3s;
        -moz-animation: swiperRc 3s;	/* Firefox */
        -webkit-animation: swiperRc 3s;	/* Safari 和 Chrome */
        -o-animation: swiperRc 3s;	/* Opera */
        .insuranceAbout_top{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .insuranceAbout_bot{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/index/right.png') no-repeat right;
          font-weight: 900;
        }
      }
    }
    .insuranceCon11_right{
      position: relative;
      font-size: 14px;
      line-height: 24px;
      color: #80888f;
      padding:50px 20px;
      padding-left: 0;
      padding-right: 0;
      box-sizing: border-box;
      text-align: justify; /* 使段落两端对齐 */
      text-align-last: left; /* 最后一行左对齐 */
      text-justify: inter-word; /* 在单词之间添加间距 */
      hyphens: auto; /* 自动断字（可选）  */
    }
    .insuranceCon11_right>span{
      position: absolute;
      left: 0;
      top: 20px;
      display: inline-block;
      background: #0168b7;
      height: 40px;
      width: 4px;
    }
    .insuranceCon11::after{
      content: '';
      clear: both;
    }
  }
  .swiper-container{//轮播入场
    animation: swiperRc 2s;
    -moz-animation: swiperRc 2s;	/* Firefox */
    -webkit-animation: swiperRc 2s;	/* Safari 和 Chrome */
    -o-animation: swiperRc 2s;	/* Opera */
  }
  @keyframes swiperRc
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-moz-keyframes swiperRc /* Firefox */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-webkit-keyframes swiperRc /* Safari 和 Chrome */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }

  @-o-keyframes swiperRc /* Opera */
  {
    from {opacity:0;}
    to {opacity: 1;}
  }
  //第二屏
  .insuranceCon2{
    height: 480px;
/*    background: url('../../assets/img/index/indexBG.jpg') no-repeat center;*/
    min-width: 1200px;
    transition: all 2s;
    -moz-transition: all 2s;	/* Firefox 4 */
    -webkit-transition: all 2s;	/* Safari 和 Chrome */
    -o-transition: all 2s;	/* Opera */
    .insuranceCon21{
      height: 100%;
      position: relative;
      &::after{
        content: '';
        display: inline-block;
        width: 50px;
        height: 100%;
        position: absolute;
        left: 0;
        top:0;
        background: linear-gradient(to right, rgba(255,255,255,1) 0% ,rgba(255,255,255,0) 100%);
      }
      &::before{
        content: '';
        display: inline-block;
        width: 50px;
        height: 100%;
        position: absolute;
        z-index: 10;
        right: 0;
        top:0;
        background: linear-gradient(to left, rgba(255,255,255,1) 0% ,rgba(255,255,255,0) 100%);
      }
      .insuranceH1{
        display: inline-block;
        width: 190px;
        position: absolute;
        top: 30px;
        left: 0;
        right: 0;
        margin: auto;
        font-size: 38px;
        color: #80888f;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        .InsHistory1{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .InsHistory2{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/index/down.png') no-repeat right;
          margin-bottom: 50px;
          font-weight: 900;
        }
        .InsHistory3{
          display: inline-block;
          height: 4px;
          width: 40px;
          background: #0168b7;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
      .insuranceSJZ{
        position: absolute;
        height: 220px;
        left: 0;
        right: 0;
        bottom: 10px;
        margin: auto;
        .insuranceLine{
          position: absolute;
          left: 0;
          // width: 100%;
          height: 1px;
          background: #ccc;
          top:5px;
          transition: all 0.6s;
          -moz-transition: all 0.6s;	/* Firefox 4 */
          -webkit-transition: all 0.6s;	/* Safari 和 Chrome */
          -o-transition: all 0.6s;	/* Opera */
        }
        .insuranceDot{
          display: inline-block;
          opacity: 1;
          width: 10px;
          height: 10px;
          position: absolute;
          transition: all 0.6s;
          -moz-transition: all 0.6s;	/* Firefox 4 */
          -webkit-transition: all 0.6s;	/* Safari 和 Chrome */
          -o-transition: all 0.6s;	/* Opera */
        }
        .insuranceDot::after{
          content: '';
          display: inline-block;
          position: absolute;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.2);
          border-radius: 50%;
        }
        .insuranceDot::before{
          content: '';
          display: inline-block;
          position: absolute;
          width: 60%;
          height: 60%;
          background: #80888f;
          border-radius: 50%;
          top: 20%;
          left: 20%;
        }
        .insuranceTitle{
          .InsuTitle{
            font-size: 28px;
            color: rgba(0,0,0,0.2);
            font-weight: 900;
            font-style:oblique;
            width: 100px;
            display: inline-block;
          }
          .InsuCon{
            color: #999;
          }
          h2{
            font-size: 14px;
            margin: 0;
            color: #80888f;
            font-weight: 400;
          }
          display: inline-block;
          height: 0px;
          position: absolute;
          font-size: 12px;
          overflow: hidden;
          transition: all 1s;
          -moz-transition: all 1s;	/* Firefox 4 */
          -webkit-transition: all 1s;	/* Safari 和 Chrome */
          -o-transition: all 1s;	/* Opera */

        }
      }
    }
    /* for Chrome */
    .insuranceCon21::-webkit-scrollbar {
        display: none;
    }
  }
  // 第三屏
  .insuranceCon3{
    height: 500px;
    .insuranceCon31{
      position: relative;
      .receivingPrizes{
        display: inline-block;
        width: 350px;
        position: absolute;
        top: 30px;
        left: 0;
        right: 0;
        margin: auto;
        font-size: 38px;
        color: #80888f;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        text-align: center;
        .receivingPrizes1{
          display: inline-block;
          width: 100%;
          font-size: 32px;
          font-weight: 900;
        }
        .receivingPrizes2{
          display: inline-block;
          width: 100%;
          font-size: 22px;
          background: url('../../assets/img/index/down.png') no-repeat 240px;
          margin-bottom: 50px;
          font-weight: 900;
        }
        .receivingPrizes3{
          display: inline-block;
          height: 4px;
          width: 40px;
          background: #0168b7;
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
        }
      }
    }
    .insuranceCon32{
      height: 200px;
      position: absolute;
      top: 230px;
      left: 0;
      right: 0;
      margin: auto;
      .con32KP{
        padding: 30px;
        box-sizing: border-box;
        font-size: 12px;
        display: inline-block;
        background: #fff;
        width: 400px;
        height: 540px;
        box-shadow: 0px 0px 40px rgba(0,0,0,0.2);
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
        position: absolute;
      }
      .con32KP>div{
        margin-bottom: 30px;
        transition: all 1s;
        -moz-transition: all 1s;	/* Firefox 4 */
        -webkit-transition: all 1s;	/* Safari 和 Chrome */
        -o-transition: all 1s;	/* Opera */
      }
      .con32KP>div>span:nth-of-type(1){
        font-size: 16px;
        color: #80888f;
        line-height: 40px;
      }
      .con32KP>div>span:nth-of-type(2){
        font-size: 14px;
        color: #80888f;
        margin-bottom: 20px;
      }
    }
  }
    
  /*.insuranceCon32::after{
    content: '';
    display: inline-block;
    width: 100px;
    height: 100%;
    background: red;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 3;
    background: linear-gradient(to right, rgba(255,255,255,1) 0% ,rgba(255,255,255,0) 100%);
  }
  .insuranceCon32::before{
    content: '';
    display: inline-block;
    width: 100px;
    height: 100%;
    background: red;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 3;
    background: linear-gradient(to left, rgba(255,255,255,1) 0% ,rgba(255,255,255,0) 100%);
  }*/
  .ZhuanY{
    transform:rotate(0deg);
    -ms-transform:rotate(0deg); 	/* IE 9 */
    -moz-transform:rotate(0deg); 	/* Firefox */
    -webkit-transform:rotate(0deg); /* Safari 和 Chrome */
    -o-transform:rotate(0deg); 	/* Opera */
  }
  .ZhuanN{
    transform:rotate(360deg);
    -ms-transform:rotate(360deg); 	/* IE 9 */
    -moz-transform:rotate(360deg); 	/* Firefox */
    -webkit-transform:rotate(360deg); /* Safari 和 Chrome */
    -o-transform:rotate(360deg); 	/* Opera */
    }



    
  /*公司主题介绍*/
  .zhutijieshao{
    height: 486px;
    position: relative;
    .receivingPrizes{
      display: inline-block;
      width: 350px;
      position: absolute;
      top: 30px;
      left: 0;
      right: 0;
      margin: auto;
      font-size: 38px;
      color: #80888f;
      transition: all 1s;
      -moz-transition: all 1s;	/* Firefox 4 */
      -webkit-transition: all 1s;	/* Safari 和 Chrome */
      -o-transition: all 1s;	/* Opera */
      text-align: center;
      .receivingPrizes1{
        display: inline-block;
        width: 100%;
        font-size: 32px;
        font-weight: 900;
      }
      .receivingPrizes2{
        display: inline-block;
        width: 100%;
        font-size: 22px;
        background: url('../../assets/img/index/down.png') no-repeat 260px;
        margin-bottom: 50px;
        font-weight: 900;
      }
      .receivingPrizes3{
        display: inline-block;
        height: 4px;
        width: 40px;
        background: #0168b7;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    .zhutiSend{
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      position: absolute;
      
    }
    .zhutiSend>div{
      text-align: center;
      margin: 0px 20px;
      
      padding: 30px;
      padding: 0;
      width: 30%;
      display: flex;
      flex-direction: column;
        justify-content: start;
        align-items: center;

      h3{
        font-size: 20px;
        color: #80888f;
        display: inline-block;
        // text-align: left;
        width: 50%;
        position: relative;
        font-weight: 400;
        color: #1e2128;
/*        border-bottom: #0168b7 1px solid;*/
      }
      
      span{
        display: inline-block;
        
        width: 100%;
        font-size: 14px;
        color: #80888f;
        
        text-align: justify; /* 使段落两端对齐 */
        text-align-last: left; /* 最后一行左对齐 */
        text-justify: inter-word; /* 在单词之间添加间距 */
        hyphens: auto; /* 自动断字（可选）  */
      }
      img{
        object-fit:contain;
        width: 100%;
        height: 100%;
        
      }
    }
  }
  .zhutiSendImgDiv{
    display: inline-block;
    width:200px;
    height: 80px;
    position: relative;
    display: inline-flex;
    align-items: center;
  }
}
.zhutiSend>div:nth-of-type(1) img{
  height: 36px !important;
}
.zhutiSend>div:nth-of-type(3) img{
  height: 64px !important;
}
.insurance{
  .swiper-slide {
    transition: transform 0.3s ease;
    transform: scale(1); /* 默认缩小 */
    
  }
  .swiper-slide-next{
    /*transform:translateX(105px) !important;*/
  }
  .swiper-slide-prev{
   /*transform:translateX(-105px) !important;*/
  }
  
  .swiper-slide-active,
  .swiper-slide-duplicate-active {
    transform: scale(1); /* 激活状态放大 */
    z-index:1;
    transform-origin: 50% 50%;
    .luoIndexBITitle{
      transform:translateY(0) !important;
    }
  }
  .swiper-container-wrapper {
    display: flex; /* 使用 flex 布局 */
    align-items: flex-start; /* 对齐方式 */
  }
  
  .swiper-container {
    width: 100%; /* 每个 Swiper 占据一半宽度 */
    height: 258px; /* 设置高度 */
    margin: 0; /* 移除外边距 */
  }
  
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    
  }
  
  .luoIndexBI{
    display: flex;
    
    position:relative;
    width: 100%;
    
    border-radius: 10px;
    
    
    /*box-shadow: 0 0 10px rgba(2, 72, 104, 1);*/
    &::after{
      content: '';
      display: inline-block;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      right: 0;
      z-index: 10;    
      
    }
    img{
      width: 100%;
      display:block;
      position:absolute;
      bottom:24px;
      left:0;
    }
    .luoIndexBITitle{
      font-size: 12px;
      display: block;
      
      width:100%;
      text-align: center;
      color: #fff;
      position:absolute;
      bottom:0;
      left:0;
      height: 24px;
      line-height: 24px;
      z-index:1;
       background: linear-gradient(to top, rgba(0,0,0,0.8),rgba(0,0,0,0.1)); 
       background: rgba(0, 0, 0, 0.4);
       background: rgba(0, 0, 0, 0);
       
      transform:translateY(100px);
      transform:translateY(0);
      transition: all 0.3s ease-in-out;
      -moz-transition: all 0.3s ease-in-out;	/* Firefox 4 */
      -webkit-transition: all 0.3s ease-in-out;	/* Safari 和 Chrome */
      -o-transition: all 0.3s ease-in-out;	/* Opera */

    }
  }

  .swiper-button-next{
/*    background:url();*/
  }

}

/* 统一动画定义 */
.ribbon-layer {
  fill: none;
  stroke-linecap: round;
  stroke-width: 0.2;
  stroke-dasharray:900,900;
  stroke-dashoffset: 900;
  opacity: 0.8;
}
.ribbon-layer:nth-of-type(4n) {
  animation: history_index 2.8s ease-in forwards 1;
  animation-delay:0.0s;
}
.ribbon-layer:nth-of-type(4n+1) {
  animation: history_index 2.6s ease-in forwards 1;
  animation-delay:.2s;
}
.ribbon-layer:nth-of-type(4n+2) {
  animation: history_index 2.4s ease-in forwards 1;
  animation-delay:0.4s;
}
.ribbon-layer:nth-of-type(4n+3) {
  animation: history_index 2.2s ease-in forwards 1;
  animation-delay:0.6s;
}

@keyframes history_index {
  0% {
    stroke-dashoffset: 900;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
.index_sidai_svg{
  display: inline-block;
  width: 100%;
  
  position: absolute;
  
  left: 0;
  right: 0;
  top: 220px;
}
/* 公司历史 */
.new_index_history{
  display: flex;
  position: absolute;
  height: 440px;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
  align-items:center;
  .new_index_history_title{
    height: 140px;
    font-size: 12px;
    width: 100%;
    position: relative;
    span{
      font-size: 28px;
      color: rgba(0, 0, 0, 0.2);
      font-weight: 900;
      font-style: oblique;
      width: 100px;
      display: inline-block;
    }
    h2{
      font-size: 14px;
      margin: 0;
      color: #80888f;
      font-weight: 400;
      max-width: 220px;
    }
  }
  
}
.path-marker {
  position: absolute;
  width: 14px;
  height: 14px;
  background: #0168b763;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
  opacity: 0;
  animation: showpathmarker 0.6s ease-in forwards 1;
  
  .path-wenan{
    position: absolute;
    left: -120px;
    right: 0;
    margin: auto;
    min-width: 260px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 6;
    h2{
      font-size: 20px;
      color: rgba(0, 0, 0, 0.2);
      color: #0168b7;
      font-weight: 900;
      font-style: oblique;
      display:block;
      margin: 0;
      text-align: center;
      margin-bottom: 10px;
    }
    span{
      font-size: 14px;
      margin: 0;
      color: #80888f;
      display: block;
      font-weight: 400;
      text-align: center;
      text-align: left;
    }
  }
  &::after{
    content: '';
    display: inline-block;
    width: 6px;
    height: 6px;
    background: #0168b7;
    border-radius: 50%;
    position: absolute;
    left: 4px;
    top: 4px;
    opacity: 0;
    animation: showpathmarker 1s ease-in forwards 1;
    
  }
}


.path-marker:nth-of-type(2n){
  &::before{
    content: '';
    display: inline-block;
    width: 1px;
    height: 64px;
    background: #0168b763;
    background: linear-gradient(to bottom, #0168b721, #0168b763);
    border-radius: 50%;
    position: absolute;
    left: 0px;
    right: 0;
    top: -64px;
    margin: 0 auto;
  }
  .path-wenan{
    top: -260px;
    justify-content: flex-end;
  }
}
.path-marker:nth-of-type(2n+1){
  &::before{
    content: '';
    display: inline-block;
    width: 1px;
    height: 64px;
    background: #0168b763;
    background: linear-gradient(to top, #0168b70a, #0168b763);

    border-radius: 50%;
    position: absolute;
    left: 0px;
    right: 0;
    bottom: -64px;
    margin: 0 auto;
  }
  .path-wenan{
    top: 70px;
    justify-content: flex-start;
  }
}

.path-marker:nth-of-type(2){
  animation-delay:2s;
}
.path-marker:nth-of-type(2){
  animation-delay:2.2s;
}
.path-marker:nth-of-type(3){
  animation-delay:2.4s;
}
.path-marker:nth-of-type(4){
  animation-delay:2.6s;
}
.path-marker:nth-of-type(5){
  animation-delay:2.8s;
}
.path-marker:nth-of-type(6){
  animation-delay:3s;
}
.path-marker:nth-of-type(7){
  animation-delay:3.2s;
}
.path-marker:nth-of-type(8){
  animation-delay:3.4s;
}

@keyframes showpathmarker {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.indexBigBanner{
  
  width: 1200px;
  height: calc(100vh - 60px); /* 内容高度为视口高度减去导航栏高度 */
  height: 627px;
  background: #ccc;
  margin: 0 auto;
  min-width: 1200px;
  position: relative;
  overflow: hidden;
  &::after{
    content: '';
    display: inline-block;
    height: 47.5%;
    position: absolute;
    width: 100%;
    background: rgba(0, 0, 0, 0.55);
    z-index: 2;
    bottom: 0;
    right: 0;
  }
  &::before{
    content: '';
    display: inline-block;
    height: 100%;
    position: absolute;
    width: 100%;
    background: rgba(255,255,255,0.2);
    z-index: 2;
    bottom: 0;
    right: 0;
  }
  .indexAbanner{
    display: block;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 1;
    object-fit: cover ;
    height: 100%;
  }
  
  .indexBigTextBg{
    display: inline-block;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    background: rgba(2, 72, 104, 0.0);
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    padding-top: 310px;
    padding-top: 344px;
    padding-left: 20px;
  }
  .titleTY_top,.titleTY_bot{
    padding-left: 0 !important;
  }
  .indexBigTextContent{
    display: inline-block;
    width: 940px;
    width: 100%;
    color: #fff;
    font-size: 14px;
    
    /*padding: 10px;*/
    letter-spacing:1px;
    animation: indexBigBannertextShow 1s forwards;
    -moz-animation: indexBigBannertextShow 1s forwards;	/* Firefox */
    -webkit-animation: indexBigBannertextShow 1s forwards;	/* Safari 和 Chrome */
    -o-animation: indexBigBannertextShow 1s forwards;	/* Opera */
    animation-delay:0.2s;
    opacity: 0;
    text-align: justify;
    -moz-text-align-last: left;
    text-align-last: left;
    text-justify: inter-word;
    -ms-hyphens: auto;
    hyphens: auto;

  }
  .titleTY_top{
    animation: indexBigBannertextShow 1s forwards;
    -moz-animation: indexBigBannertextShow 1s forwards;	/* Firefox */
    -webkit-animation: indexBigBannertextShow 1s forwards;	/* Safari 和 Chrome */
    -o-animation: indexBigBannertextShow 1s forwards;	/* Opera */
    opacity: 0;

  }
  .titleTY_bot{
    animation: indexBigBannertextShow 1s forwards;
    -moz-animation: indexBigBannertextShow 1s forwards;	/* Firefox */
    -webkit-animation: indexBigBannertextShow 1s forwards;	/* Safari 和 Chrome */
    -o-animation: indexBigBannertextShow 1s forwards;	/* Opera */
    animation-delay:0.1s;

  }
  @keyframes indexBigBannertextShow
  {
    from {
      opacity: 0;
      transform:translateY(100px);
      -webkit-transform:translateY(100px);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:translateY(100px);     /*兼容-moz-引擎浏览器*/
    }
    to {
      opacity: 1;
      transform:translateY(0px);
      -webkit-transform:translateY(0px);  /*兼容-webkit-引擎浏览器*/
      -moz-transform:translateY(0px);     /*兼容-moz-引擎浏览器*/
    }
  }
  .indexBigBannerSwiper{
    display: inline-block;
    height: 158px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 999;
    padding: 0 20px;
    box-sizing: border-box;
    .luoIndexBI{
      position: absolute;
      bottom: 10px;
    }
    .swiper-container{
      height: 168px;
      img{
        display: block;
        width: 100%;
        
      }
    }
    .swiper-wrapper{
      position: relative;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-transition-property: -webkit-transform;
      transition-property: -webkit-transform;
      -o-transition-property: transform;
      transition-property: transform;
      transition-property: transform, -webkit-transform;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
    }
  }
  .indexBigBannerSwiper:hover{
    .swiper_button_prev_new{
      opacity: 1;
    }
    .swiper_button_next_new{
      opacity: 1;
    }
  }
  .swiper_button_next_new{
    display: inline-block;
    width: 20px;
    height: 119px;
    position: absolute;
    right: 0;
    top: 29px;
    background: rgba(0, 0, 0, 0.4);
    background: rgba(0, 0, 0, 0);
    transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;	/* Firefox 4 */
    -webkit-transition: all 0.3s ease-in-out;	/* Safari 和 Chrome */
    -o-transition: all 0.3s ease-in-out;	/* Opera */
    opacity: 0;
    cursor: pointer;
    &::after{
      content: '';
      display: inline-block;
      height: 100%;
      width: 100%;
      background:  url('data:image/png;base64,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') center no-repeat;
      background-size: 120% auto;
    }
  }
  .swiper_button_prev_new{
    display: inline-block;
    width: 20px;
    height: 119px;
    position: absolute;
    left: 0;
    top: 29px;
    background: rgba(0, 0, 0, 0.4);
    background: rgba(0, 0, 0, 0);
    transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;	/* Firefox 4 */
    -webkit-transition: all 0.3s ease-in-out;	/* Safari 和 Chrome */
    -o-transition: all 0.3s ease-in-out;	/* Opera */
    opacity: 0;
    cursor: pointer;
    &::after{
      content: '';
      display: inline-block;
      height: 100%;
      width: 100%;
      background:  url('data:image/png;base64,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') center no-repeat;
      background-size: 120% auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/insurance.vue